(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  // Import SASS

var $31467fba5e5d38e9$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ "use strict";
var $31467fba5e5d38e9$var$OFI = "bfred-it:object-fit-images";
var $31467fba5e5d38e9$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $31467fba5e5d38e9$var$testImg = typeof Image === "undefined" ? {
    style: {
        "object-position": 1
    }
} : new Image();
var $31467fba5e5d38e9$var$supportsObjectFit = "object-fit" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsObjectPosition = "object-position" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsOFI = "background-size" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsCurrentSrc = typeof $31467fba5e5d38e9$var$testImg.currentSrc === "string";
var $31467fba5e5d38e9$var$nativeGetAttribute = $31467fba5e5d38e9$var$testImg.getAttribute;
var $31467fba5e5d38e9$var$nativeSetAttribute = $31467fba5e5d38e9$var$testImg.setAttribute;
var $31467fba5e5d38e9$var$autoModeEnabled = false;
function $31467fba5e5d38e9$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $31467fba5e5d38e9$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$31467fba5e5d38e9$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $31467fba5e5d38e9$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $31467fba5e5d38e9$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $31467fba5e5d38e9$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $31467fba5e5d38e9$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($31467fba5e5d38e9$var$nativeGetAttribute.call(img, "src") !== placeholder) $31467fba5e5d38e9$var$nativeSetAttribute.call(img, "src", placeholder);
}
function $31467fba5e5d38e9$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($31467fba5e5d38e9$var$onImageReady, 100, img, callback);
}
function $31467fba5e5d38e9$var$fixOne(el) {
    var style = $31467fba5e5d38e9$var$getStyle(el);
    var ofi = el[$31467fba5e5d38e9$var$OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style["object-fit"] === "fill") return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $31467fba5e5d38e9$var$supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $31467fba5e5d38e9$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = "";
        try {
            $31467fba5e5d38e9$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn("https://bit.ly/ofi-old-browser");
        }
    }
    $31467fba5e5d38e9$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";
    if (/scale-down/.test(style["object-fit"])) $31467fba5e5d38e9$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = "contain";
        else el.style.backgroundSize = "auto";
    });
    else el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    $31467fba5e5d38e9$var$onImageReady(ofi.img, function(img) {
        $31467fba5e5d38e9$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $31467fba5e5d38e9$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : "src"];
        },
        set: function set(value, prop) {
            el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : "src"] = value;
            $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $31467fba5e5d38e9$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
        get: function get() {
            return descriptors.get("currentSrc");
        }
    });
    Object.defineProperty(el, "srcset", {
        get: function get() {
            return descriptors.get("srcset");
        },
        set: function set(ss) {
            return descriptors.set(ss, "srcset");
        }
    });
}
function $31467fba5e5d38e9$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$31467fba5e5d38e9$var$OFI] && el[$31467fba5e5d38e9$var$OFI].img && (name === "src" || name === "srcset") ? el[$31467fba5e5d38e9$var$OFI].img : el;
    }
    if (!$31467fba5e5d38e9$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $31467fba5e5d38e9$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $31467fba5e5d38e9$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $31467fba5e5d38e9$var$fix(imgs, opts) {
    var startAutoMode = !$31467fba5e5d38e9$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";
    if ($31467fba5e5d38e9$var$supportsObjectPosition && !opts.skipTest || !$31467fba5e5d38e9$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === "img") imgs = document.getElementsByTagName("img");
    else if (typeof imgs === "string") imgs = document.querySelectorAll(imgs);
    else if (!("length" in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$31467fba5e5d38e9$var$OFI] = imgs[i][$31467fba5e5d38e9$var$OFI] || {
            skipTest: opts.skipTest
        };
        $31467fba5e5d38e9$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") $31467fba5e5d38e9$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $31467fba5e5d38e9$var$autoModeEnabled = true;
        imgs = "img"; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener("resize", $31467fba5e5d38e9$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$31467fba5e5d38e9$var$fix.supportsObjectFit = $31467fba5e5d38e9$var$supportsObjectFit;
$31467fba5e5d38e9$var$fix.supportsObjectPosition = $31467fba5e5d38e9$var$supportsObjectPosition;
$31467fba5e5d38e9$var$hijackAttributes();
$31467fba5e5d38e9$exports = $31467fba5e5d38e9$var$fix;


function $3bcce9df15a46784$export$2e2bcd8739ae039(el) {
    var header = document.querySelector(el);
    document.addEventListener("scroll", function() {
        if (window.pageYOffset > 200) header.classList.add("scrolled");
        else header.classList.remove("scrolled");
    });
}


/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */ (function() {
    var isIe = /(trident|msie)/i.test(navigator.userAgent);
    if (isIe && document.getElementById && window.addEventListener) window.addEventListener("hashchange", function() {
        var id = location.hash.substring(1), element;
        if (!/^[A-z0-9_-]+$/.test(id)) return;
        element = document.getElementById(id);
        if (element) {
            if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) element.tabIndex = -1;
            element.focus();
        }
    }, false);
})();


function $8ce4587015debc57$export$2e2bcd8739ae039() {
    var players = [];
    if (typeof videoPlayerList === "undefined") return;
    for(var i = 0; i < videoPlayerList.length; i++){
        var curplayer = $8ce4587015debc57$var$createPlayer(videoPlayerList[i]);
        players[i] = curplayer;
    }
    return players;
}
function $8ce4587015debc57$var$createPlayer(playerInfo) {
    return new YT.Player(playerInfo.id, {
        height: playerInfo.height,
        width: playerInfo.width,
        videoId: playerInfo.videoId,
        playerVars: playerInfo.playerVars,
        events: playerInfo.events
    });
}


/**
 * File menus.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */ (function() {
    var button, menu, links, i, len;
    btnAttrib = "data-menu-toggle"; // Attribute name that buttons use to target a menu
    menuAttrib = "data-menu"; // Attribute where menu name is set
    stateName = "toggled"; // the class the menu and button get when clicked
    menuListName = "";
    // Get buttons that target a menu
    buttons = document.querySelectorAll("[" + btnAttrib + "]");
    if ("undefined" === typeof buttons) return;
    // Go over each button and setup menu toggles
    buttons.forEach(function(button) {
        var _loop = function() {
            var link = links[i];
            var listLength = links.length;
            link.addEventListener("focus", function() {
                toggleFocus(link, listLength, listName);
            }, false);
            link.addEventListener("blur", function() {
                toggleFocus(link, listLength, listName);
            }, false);
        };
        var menuName, menu, listName, list, links;
        menuName = button.getAttribute(btnAttrib);
        menu = document.querySelector("[" + menuAttrib + '="' + menuName + '"]');
        // Hide menu toggle button if menu is empty and return early.
        if ("undefined" === typeof menu) return;
        submenuAccess(menu);
        linkedButtons = document.querySelectorAll("[" + btnAttrib + '="' + menuName + '"]');
        button.onclick = function() {
            //toggleState(button, stateName);							// Give button state class
            toggleState(menu, stateName); // Give menu state class
            toggleState(document.body, menuName + "-" + stateName); // Give body menu name + state class
            if ("undefined" != typeof linkedButtons) linkedButtons.forEach(function(linkedButton) {
                toggleState(linkedButton, stateName); // Give button state class
            });
        };
        list = menu.getElementsByTagName("ul")[0];
        // Hide menu toggle button if menu is empty and return early.
        if ("undefined" === typeof list) return;
        listName = menuName + "-list";
        list.setAttribute("aria-expanded", "false");
        if (-1 === list.className.indexOf(listName)) list.className += " " + listName;
        links = list.getElementsByTagName("a");
        // Each time a menu link is focused or blurred, toggle focus.
        for(i = 0, len = links.length; i < len; i++)_loop();
    });
    // General function to change state
    function toggleState(el, state) {
        el.classList.toggle(state);
        if (-1 !== el.className.indexOf(state)) el.setAttribute("aria-expanded", "false");
        else el.setAttribute("aria-expanded", "true");
    }
    /**
	 * Sets or removes .focus class on an element.
	 */ function toggleFocus(self, listLength, listName) {
        // Move up through the ancestors of the current link until we hit .nav-menu.
        var parentMenu = self.closest(".menu");
        while(-1 === self.className.indexOf(listName)){
            // On li elements toggle the class .focus.
            if ("li" === self.tagName.toLowerCase()) {
                if (-1 !== self.className.indexOf("focus")) self.className = self.className.replace(" focus", "");
                else self.className += " focus";
            }
            self = self.parentElement;
        }
    }
    /**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */ function submenuAccess(container) {
        // console.log('go');
        var touchStartFn, i, parentLink = container.querySelectorAll(".menu-item-has-children > a, .page_item_has_children > a");
        if ("ontouchstart" in window) {
            touchStartFn = function touchStartFn(e) {
                var menuItem = this.parentNode, i;
                if (!menuItem.classList.contains("focus")) {
                    e.preventDefault();
                    for(i = 0; i < menuItem.parentNode.children.length; ++i){
                        if (menuItem === menuItem.parentNode.children[i]) continue;
                        menuItem.parentNode.children[i].classList.remove("focus");
                    }
                    menuItem.classList.add("focus");
                } else menuItem.classList.remove("focus");
            };
            for(i = 0; i < parentLink.length; ++i)parentLink[i].addEventListener("touchstart", touchStartFn, false);
        }
    }
})();


// Object.keys
var $841e85ee868dd0d4$var$win = window;
var $841e85ee868dd0d4$export$27f233d61a9e2fa4 = $841e85ee868dd0d4$var$win.requestAnimationFrame || $841e85ee868dd0d4$var$win.webkitRequestAnimationFrame || $841e85ee868dd0d4$var$win.mozRequestAnimationFrame || $841e85ee868dd0d4$var$win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
};


var $9960623eeb62d695$var$win = window;
var $9960623eeb62d695$export$75aab3dbee8deceb = $9960623eeb62d695$var$win.cancelAnimationFrame || $9960623eeb62d695$var$win.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
};


function $8def800bd2c631ba$export$8b58be045bf06082() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}


function $35e19be817102b97$export$79d1167a24e4e930(value) {
    return [
        "true",
        "false"
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


function $2033929a7fec2873$export$1f73f60bdb811cb1(storage, key, value, access) {
    if (access) try {
        storage.setItem(key, value);
    } catch (e) {}
    return value;
}


function $d7f329ede83197d7$export$ff0ccbbb2d1923f6() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return "tns" + window.tnsId;
}


// get css-calc 
// @return - false | calc | -webkit-calc | -moz-calc
// @usage - var calc = getCalc(); 
function $b7572e32da8ee13a$export$135b49d4bc2964c6() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement("body");
        body.fake = true;
    }
    return body;
}


var $7979bb3e1890db7f$export$9dfbf2fa8806212d = document.documentElement;


function $58ed177cc807d047$export$4078b67b5eba0c5(body) {
    var docOverflow = "";
    if (body.fake) {
        docOverflow = (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = "";
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).style.overflow = "hidden";
        (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).appendChild(body);
    }
    return docOverflow;
}



function $af64f50f3d11d5e1$export$81b27fa331809b9b(body, docOverflow) {
    if (body.fake) {
        body.remove();
        (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).offsetHeight;
    }
}


function $155687d682cfd223$export$42bfa9b2d4dad91a() {
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), div = doc.createElement("div"), result = false;
    body.appendChild(div);
    try {
        var str = "(10px * 10)", vals = [
            "calc" + str,
            "-moz-calc" + str,
            "-webkit-calc" + str
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 100) {
                result = val.replace(str, "");
                break;
            }
        }
    } catch (e) {}
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return result;
}


// get subpixel support value
// @return - boolean



function $427f5d1737b400d1$export$7b334bfa4e585549() {
    // check subpixel layout supporting
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), wrapper = doc.createElement("div"), outer = doc.createElement("div"), str = "", count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for(var i = 0; i < count; i++)str += "<div></div>";
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : wrapper.remove();
    return supported;
}





function $3520b2cd5f778f00$export$48976c233ddfebe2() {
    if (window.matchMedia || window.msMatchMedia) return true;
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), div = doc.createElement("div"), style = doc.createElement("style"), rule = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}", position;
    style.type = "text/css";
    div.className = "tns-mq-test";
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle["position"];
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return position === "absolute";
}


// create and append style sheet
function $a694349ebc945c16$export$d07d6a5154e3b470(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
    // Add nonce attribute for Content Security Policy
    if (nonce) style.setAttribute("nonce", nonce);
    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector("head").appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}


// cross browsers addRule method

function $1a90d19cf20fcd68$export$bf97e331026f75ba(sheet, selector, rules, index) {
    // return raf(function() {
    "insertRule" in sheet ? sheet.insertRule(selector + "{" + rules + "}", index) : sheet.addRule(selector, rules, index);
// });
}


// cross browsers addRule method

function $290e8f413288fb29$export$271e480b8a432c4a(sheet, index) {
    // return raf(function() {
    "deleteRule" in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
// });
}


function $97bce8d8c89c4190$export$ccd7e907f4f59892(sheet) {
    var rule = "insertRule" in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}


function $d546b5ddaa1f720a$export$c796d9d3e501591f(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}


function $c56a54e7f265475e$export$83b6d73568c72b60(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = "horizontal";
    else if (gap <= range) direction = "vertical";
    return direction;
}


// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function $c4d187697d100d42$export$4b80e395e36b5a56(arr, callback, scope) {
    for(var i = 0, l = arr.length; i < l; i++)callback.call(scope, arr[i], i);
}


var $51f4ed50b4a4690f$export$8b753db5fc454027 = "classList" in document.createElement("_");


var $e4fd7ed3fd7a85e9$export$4ea3d958472af68f = (0, $51f4ed50b4a4690f$export$8b753db5fc454027) ? function hasClass(el, str) {
    return el.classList.contains(str);
} : function(el, str) {
    return el.className.indexOf(str) >= 0;
};



var $58aedeabc9b57e85$export$d2cf6cd1dc7067d3 = (0, $51f4ed50b4a4690f$export$8b753db5fc454027) ? function addClass(el, str) {
    if (!(0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.classList.add(str);
} : function(el, str) {
    if (!(0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.className += " " + str;
};



var $91ec85d1e7d05de6$export$c2255604a80b4506 = (0, $51f4ed50b4a4690f$export$8b753db5fc454027) ? function removeClass(el, str) {
    if ((0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.classList.remove(str);
} : function(el, str) {
    if ((0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.className = el.className.replace(str, "");
};


function $92c19f95ffd892da$export$5608640b1bf2f6d7(el, attr) {
    return el.hasAttribute(attr);
}


function $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0(el, attr) {
    return el.getAttribute(attr);
}


function $938c4d79fdcca292$export$ff45fc08c57bb9d0(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}


function $fc4786701fd188a9$export$7e45664a2081efb1(els, attrs) {
    els = (0, $938c4d79fdcca292$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== "[object Object]") return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}



function $374312ce9bdfbef2$export$711225beb0f1ef57(els, attrs) {
    els = (0, $938c4d79fdcca292$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}


function $e10011047bee640d$export$19b645cc08e75c7c(nl) {
    var arr = [];
    for(var i = 0, l = nl.length; i < l; i++)arr.push(nl[i]);
    return arr;
}


function $b6b059ab1be1bedb$export$7669482c90f5c50f(el, forceHide) {
    if (el.style.display !== "none") el.style.display = "none";
}


function $7e4aafbbd7b5f772$export$998191bfdf710c72(el, forceHide) {
    if (el.style.display === "none") el.style.display = "";
}


function $807f43eecb4b0d07$export$795910f5f15a9633(el) {
    return window.getComputedStyle(el).display !== "none";
}


function $d4329b30388a7ff3$export$d7ea39ebd37f24a6(props) {
    if (typeof props === "string") {
        var arr = [
            props
        ], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = [
            "Webkit",
            "Moz",
            "ms",
            "O"
        ];
        prefixes.forEach(function(prefix) {
            if (prefix !== "ms" || props === "transform") arr.push(prefix + Props);
        });
        props = arr;
    }
    var el = document.createElement("fakeelement"), len = props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}





function $ecedc1b76fb35f4f$export$c0585cbcaae92b06(tf) {
    if (!tf) return false;
    if (!window.getComputedStyle) return false;
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), el = doc.createElement("p"), has3d, cssTF = tf.length > 9 ? "-" + tf.slice(0, -9).toLowerCase() + "-" : "";
    cssTF += "transform";
    // Add it to the body to get the computed style
    body.insertBefore(el, null);
    el.style[tf] = "translate3d(1px,1px,1px)";
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}


// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $0b7f95712488e6e9$export$41e71ffeacbff65e(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = "webkit" + propOut + "End";
    else if (/^O/.test(propIn)) endProp = "o" + propOut + "End";
    else if (propIn) endProp = propOut.toLowerCase() + "end";
    return endProp;
}


// Test via a getter in the options object to see if the passive property is accessed
var $6deed872f0ad204e$var$supportsPassive = false;
try {
    var $6deed872f0ad204e$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $6deed872f0ad204e$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $6deed872f0ad204e$var$opts);
} catch (e) {}
var $6deed872f0ad204e$export$555390bf67cc3262 = $6deed872f0ad204e$var$supportsPassive ? {
    passive: true
} : false;


function $2d450f9a54805e30$export$aadfb65bee660f96(el, obj, preventScrolling) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 && !preventScrolling ? (0, $6deed872f0ad204e$export$555390bf67cc3262) : false;
        el.addEventListener(prop, obj[prop], option);
    }
}



function $d58278b019a227a5$export$da5f6eb3bb522cd(el, obj) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 ? (0, $6deed872f0ad204e$export$555390bf67cc3262) : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}


function $7eff8d4ddf1a4c34$export$ada873a34909da65() {
    return {
        topics: {},
        on: function on(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function off(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function emit(eventName, data) {
            data.type = eventName;
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data, eventName);
            });
        }
    };
}


function $9e1eeb371de7034f$export$e2705a83c013f564(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf("%") >= 0 ? "%" : "px", to = to.replace(unit, ""), from = Number(element.style[attr].replace(prefix, "").replace(postfix, "").replace(unit, "")), positionTick = (to - from) / duration * tick, running;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}


if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
// ChildNode.remove
if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
var $665047dee130590c$export$51fe319e24d9d8c9 = function tns1(options) {
    options = (0, $8def800bd2c631ba$export$8b58be045bf06082)({
        container: ".slider",
        mode: "carousel",
        axis: "horizontal",
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: "top",
        controlsText: [
            "prev",
            "next"
        ],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: "top",
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: "top",
        autoplayTimeout: 5000,
        autoplayDirection: "forward",
        autoplayText: [
            "start",
            "stop"
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: "tns-fadeIn",
        animateOut: "tns-fadeOut",
        animateNormal: "tns-normal",
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: ".tns-lazy-img",
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
    }, options || {});
    var doc = document, win = window, KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date;
        try {
            tnsStorage = win.localStorage;
            if (tnsStorage) {
                tnsStorage.setItem(uid, uid);
                localStorageAccess = tnsStorage.getItem(uid) == uid;
                tnsStorage.removeItem(uid);
            } else localStorageAccess = false;
            if (!localStorageAccess) tnsStorage = {};
        } catch (e) {
            localStorageAccess = false;
        }
        if (localStorageAccess) {
            // remove storage when browser version changes
            if (tnsStorage["tnsApp"] && tnsStorage["tnsApp"] !== browserInfo) [
                "tC",
                "tPL",
                "tMQ",
                "tTf",
                "t3D",
                "tTDu",
                "tTDe",
                "tADu",
                "tADe",
                "tTE",
                "tAE"
            ].forEach(function(item) {
                tnsStorage.removeItem(item);
            });
            // update browserInfo
            localStorage["tnsApp"] = browserInfo;
        }
    }
    var CALC = tnsStorage["tC"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tC"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tC", (0, $155687d682cfd223$export$42bfa9b2d4dad91a)(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage["tPL"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tPL"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tPL", (0, $427f5d1737b400d1$export$7b334bfa4e585549)(), localStorageAccess), CSSMQ = tnsStorage["tMQ"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tMQ"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tMQ", (0, $3520b2cd5f778f00$export$48976c233ddfebe2)(), localStorageAccess), TRANSFORM = tnsStorage["tTf"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTf"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTf", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("transform"), localStorageAccess), HAS3DTRANSFORMS = tnsStorage["t3D"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["t3D"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "t3D", (0, $ecedc1b76fb35f4f$export$c0585cbcaae92b06)(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage["tTDu"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTDu"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTDu", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("transitionDuration"), localStorageAccess), TRANSITIONDELAY = tnsStorage["tTDe"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTDe"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTDe", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("transitionDelay"), localStorageAccess), ANIMATIONDURATION = tnsStorage["tADu"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tADu"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tADu", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("animationDuration"), localStorageAccess), ANIMATIONDELAY = tnsStorage["tADe"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tADe"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tADe", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("animationDelay"), localStorageAccess), TRANSITIONEND = tnsStorage["tTE"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTE"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTE", (0, $0b7f95712488e6e9$export$41e71ffeacbff65e)(TRANSITIONDURATION, "Transition"), localStorageAccess), ANIMATIONEND = tnsStorage["tAE"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tAE"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tAE", (0, $0b7f95712488e6e9$export$41e71ffeacbff65e)(ANIMATIONDURATION, "Animation"), localStorageAccess);
    // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function", tnsList = [
        "container",
        "controlsContainer",
        "prevButton",
        "nextButton",
        "navContainer",
        "autoplayButton"
    ], optionsElements = {};
    tnsList.forEach(function(item) {
        if (typeof options[item] === "string") {
            var str = options[item], el = doc.querySelector(str);
            optionsElements[item] = str;
            if (el && el.nodeName) options[item] = el;
            else {
                if (supportConsoleWarn) console.warn("Can't find", options[item]);
                return;
            }
        }
    });
    // make sure at least 1 slide
    if (options.container.children.length < 1) {
        if (supportConsoleWarn) console.warn("No slides found in", options.container);
        return;
    }
    // update options
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === "carousel" ? true : false;
    if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
            options = (0, $8def800bd2c631ba$export$8b58be045bf06082)(options, responsive[0]);
            delete responsive[0];
        }
        var responsiveTem = {};
        for(var key in responsive){
            var val = responsive[key];
            // update responsive
            // from: 300: 2
            // to:
            //   300: {
            //     items: 2
            //   }
            val = typeof val === "number" ? {
                items: val
            } : val;
            responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
    }
    // update options
    function updateOptions(obj) {
        for(var key in obj){
            if (!carousel) {
                if (key === "slideBy") obj[key] = "page";
                if (key === "edgePadding") obj[key] = false;
                if (key === "autoHeight") obj[key] = false;
            }
            // update responsive options
            if (key === "responsive") updateOptions(obj[key]);
        }
    }
    if (!carousel) updateOptions(options);
    // === define and set variables ===
    if (!carousel) {
        options.axis = "horizontal";
        options.slideBy = "page";
        options.edgePadding = false;
        var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === "horizontal" ? true : false, outerWrapper = doc.createElement("div"), innerWrapper = doc.createElement("div"), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) setBreakpointZone();
    if (carousel) container.className += " tns-vpfix";
    // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth, fixedWidth = getOption("fixedWidth"), edgePadding = getOption("edgePadding"), gutter = getOption("gutter"), viewport = getViewportWidth(), center = getOption("center"), items = !autoWidth ? Math.floor(getOption("items")) : 1, slideBy = getOption("slideBy"), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption("arrowKeys"), speed = getOption("speed"), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption("autoHeight"), controls = getOption("controls"), controlsText = getOption("controlsText"), nav = getOption("nav"), touch = getOption("touch"), mouseDrag = getOption("mouseDrag"), autoplay = getOption("autoplay"), autoplayTimeout = getOption("autoplayTimeout"), autoplayText = getOption("autoplayText"), autoplayHoverPause = getOption("autoplayHoverPause"), autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), sheet = (0, $a694349ebc945c16$export$d07d6a5154e3b470)(null, getOption("nonce")), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? "left" : "top", transformPrefix = "", transformPostfix = "", // index
    getIndexMax = function() {
        if (fixedWidth) return function() {
            return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
        else if (autoWidth) return function() {
            for(var i = 0; i < slideCountNew; i++){
                if (slidePositions[i] >= -rightBoundary) return i;
            }
        };
        else return function() {
            if (center && carousel && !loop) return slideCount - 1;
            else return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        };
    }(), index = getStartIndex(getOption("startIndex")), indexCached = index, displayIndex = getCurrentSlide(), indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, // resize
    resizeTimer, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? "?" : true, running = false, onInit = options.onInit, events = new (0, $7eff8d4ddf1a4c34$export$ada873a34909da65)(), // id, class
    newContainerClasses = " tns-slider tns-" + options.mode, slideId = container.id || (0, $d7f329ede83197d7$export$ff0ccbbb2d1923f6)(), disable = getOption("disable"), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
        "click": onControlsClick,
        "keydown": onControlsKeydown
    }, navEvents = {
        "click": onNavClick,
        "keydown": onNavKeydown
    }, hoverEvents = {
        "mouseover": mouseoverPause,
        "mouseout": mouseoutRestart
    }, visibilityEvent = {
        "visibilitychange": onVisibilityChange
    }, docmentKeydownEvent = {
        "keydown": onDocumentKeydown
    }, touchEvents = {
        "touchstart": onPanStart,
        "touchmove": onPanMove,
        "touchend": onPanEnd,
        "touchcancel": onPanEnd
    }, dragEvents = {
        "mousedown": onPanStart,
        "mousemove": onPanMove,
        "mouseup": onPanEnd,
        "mouseleave": onPanEnd
    }, hasControls = hasOption("controls"), hasNav = hasOption("nav"), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption("autoplay"), hasTouch = hasOption("touch"), hasMouseDrag = hasOption("mouseDrag"), slideActiveClass = "tns-slide-active", slideClonedClass = "tns-slide-cloned", imgCompleteClass = "tns-complete", imgEvents = {
        "load": onImgLoaded,
        "error": onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === "force" ? true : false;
    // controls
    if (hasControls) var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : "", prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : "", nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : "", prevIsButton, nextIsButton;
    // nav
    if (hasNav) var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : "", navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = "tns-nav-active", navStr = "Carousel Page ", navStrCurrent = " (Current Slide)";
    // autoplay
    if (hasAutoplay) var autoplayDirection = options.autoplayDirection === "forward" ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : "", autoplayHtmlStrings = [
        "<span class='tns-visually-hidden'>",
        " animation</span>"
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    if (hasTouch || hasMouseDrag) var initPosition = {}, lastPosition = {}, translateInit, disX, disY, panStart = false, rafIndex, getDist = horizontal ? function getDist(a, b) {
        return a.x - b.x;
    } : function(a, b) {
        return a.y - b.y;
    };
    // disable slider when slidecount <= items
    if (!autoWidth) resetVariblesWhenDisable(disable || freeze);
    if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = "translate";
        if (HAS3DTRANSFORMS) {
            transformPrefix += horizontal ? "3d(" : "3d(0px, ";
            transformPostfix = horizontal ? ", 0px, 0px)" : ", 0px)";
        } else {
            transformPrefix += horizontal ? "X(" : "Y(";
            transformPostfix = ")";
        }
    }
    if (carousel) container.className = container.className.replace("tns-vpfix", "");
    initStructure();
    initSheet();
    initSliderTransform();
    // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
        if (condition) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
    function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while(tem < 0)tem += slideCount;
        return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
        if (i == null) i = index;
        if (carousel) i -= cloneCount;
        while(i < 0)i += slideCount;
        return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
        var absIndex = getAbsIndex(), result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);
        // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) result = pages - 1;
        return result;
    }
    function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1;
        else {
            var str = fixedWidth ? "fixedWidth" : "items", arr = [];
            if (fixedWidth || options[str] < slideCount) arr.push(options[str]);
            if (responsive) for(var bp in responsive){
                var tem = responsive[bp][str];
                if (tem && (fixedWidth || tem < slideCount)) arr.push(tem);
            }
            if (!arr.length) arr.push(0);
            return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
    }
    function getCloneCountForLoop() {
        var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption("edgePadding") ? result + 1 : result;
    }
    function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
        return pos === "top" ? "afterbegin" : "beforeend";
    }
    function getClientWidth(el) {
        if (el == null) return;
        var div = doc.createElement("div"), rect, width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
        if (options[item]) return true;
        else {
            if (responsive) for(var bp in responsive){
                if (responsive[bp][item]) return true;
            }
            return false;
        }
    }
    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
        if (ww == null) ww = windowWidth;
        if (item === "items" && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        else {
            var result = options[item];
            if (responsive) for(var bp in responsive){
                // bp: convert string to number
                if (ww >= parseInt(bp)) {
                    if (item in responsive[bp]) result = responsive[bp][item];
                }
            }
            if (item === "slideBy" && result === "page") result = getOption("items");
            if (!carousel && (item === "slideBy" || item === "items")) result = Math.floor(result);
            return result;
        }
    }
    function getSlideMarginLeft(i) {
        return CALC ? CALC + "(" + i * 100 + "% / " + slideCountNew + ")" : i * 100 / slideCountNew + "%";
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = "";
        if (edgePaddingTem !== undefined) {
            var gap = edgePaddingTem;
            if (gutterTem) gap -= gutterTem;
            str = horizontal ? "margin: 0 " + gap + "px 0 " + edgePaddingTem + "px;" : "margin: " + edgePaddingTem + "px 0 " + gap + "px 0;";
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = "-" + gutterTem + "px", dir = horizontal ? gutterTemUnit + " 0 0" : "0 " + gutterTemUnit + " 0";
            str = "margin: 0 " + dir + ";";
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) str += getTransitionDurationStyle(speedTem);
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) return (fixedWidthTem + gutterTem) * slideCountNew + "px";
        else return CALC ? CALC + "(" + slideCountNew * 100 + "% / " + itemsTem + ")" : slideCountNew * 100 / itemsTem + "%";
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) width = fixedWidthTem + gutterTem + "px";
        else {
            if (!carousel) itemsTem = Math.floor(itemsTem);
            var dividend = carousel ? slideCountNew : itemsTem;
            width = CALC ? CALC + "(100% / " + dividend + ")" : 100 / dividend + "%";
        }
        width = "width:" + width;
        // inner slider: overwrite outer slider styles
        return nested !== "inner" ? width + ";" : width + " !important;";
    }
    function getSlideGutterStyle(gutterTem) {
        var str = "";
        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? "padding-" : "margin-", dir = horizontal ? "right" : "bottom";
            str = prop + dir + ": " + gutterTem + "px;";
        }
        return str;
    }
    function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) prefix = "-" + prefix + "-";
        return prefix;
    }
    function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + "transition-duration:" + speed / 1000 + "s;";
    }
    function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + "animation-duration:" + speed / 1000 + "s;";
    }
    function initStructure() {
        var classOuter = "tns-outer", classInner = "tns-inner", hasGutter = hasOption("gutter");
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + "-ow";
        innerWrapper.id = slideId + "-iw";
        // set container properties
        if (container.id === "") container.id = slideId;
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? " tns-subpixel" : " tns-no-subpixel";
        newContainerClasses += CALC ? " tns-calc" : " tns-no-calc";
        if (autoWidth) newContainerClasses += " tns-autowidth";
        newContainerClasses += " tns-" + options.axis;
        container.className += newContainerClasses;
        // add constrain layer for carousel
        if (carousel) {
            middleWrapper = doc.createElement("div");
            middleWrapper.id = slideId + "-mw";
            middleWrapper.className = "tns-ovh";
            outerWrapper.appendChild(middleWrapper);
            middleWrapper.appendChild(innerWrapper);
        } else outerWrapper.appendChild(innerWrapper);
        if (autoHeight) {
            var wp = middleWrapper ? middleWrapper : innerWrapper;
            wp.className += " tns-ah";
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);
        // add id, class, aria attributes
        // before clone slides
        (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, "tns-item");
            if (!item.id) item.id = slideId + "-item" + i;
            if (!carousel && animateNormal) (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateNormal);
            (0, $fc4786701fd188a9$export$7e45664a2081efb1)(item, {
                "aria-hidden": "true",
                "tabindex": "-1"
            });
        });
        // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
            var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(cloneFirst, slideClonedClass);
                (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(cloneFirst, "id");
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(cloneLast, slideClonedClass);
                    (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(cloneLast, "id");
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
    }
    function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption("autoHeight") || autoWidth || !horizontal) {
            var imgs = container.querySelectorAll("img");
            // add img load event listener
            (0, $c4d187697d100d42$export$4b80e395e36b5a56)(imgs, function(img) {
                var src = img.src;
                if (!lazyload) {
                    // not data img
                    if (src && src.indexOf("data:image") < 0) {
                        img.src = "";
                        (0, $2d450f9a54805e30$export$aadfb65bee660f96)(img, imgEvents);
                        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "loading");
                        img.src = src;
                    // data img
                    } else imgLoaded(img);
                }
            });
            // set imgsComplete
            (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $e10011047bee640d$export$19b645cc08e75c7c)(imgs), function() {
                    imgsComplete = true;
                });
            });
            // reset imgs for auto height: check visible imgs only
            if (hasOption("autoHeight")) imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
            lazyload ? initSliderTransformStyleCheck() : (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $e10011047bee640d$export$19b645cc08e75c7c)(imgs), initSliderTransformStyleCheck);
            });
        } else {
            // set container transform property
            if (carousel) doContainerTransformSilent();
            // update slider tools and events
            initTools();
            initEvents();
        }
    }
    function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function stylesApplicationCheck() {
                var left = slideItems[num].getBoundingClientRect().left;
                var right = slideItems[num - 1].getBoundingClientRect().right;
                Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
                    stylesApplicationCheck();
                }, 16);
            })();
        } else initSliderTransformCore();
    }
    function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
            setSlidePositions();
            if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) freeze = getFreeze();
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
            } else updateContentWrapperHeight();
        }
        // set container transform property
        if (carousel) doContainerTransformSilent();
        // update slider tools and events
        initTools();
        initEvents();
    }
    function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) for(var i = index, l = index + Math.min(slideCount, items); i < l; i++){
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + "%";
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateIn);
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateNormal);
        }
        // #### LAYOUT
        // ## INLINE-BLOCK VS FLOAT
        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0
        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~
        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
            if (PERCENTAGELAYOUT || autoWidth) {
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", "font-size:" + win.getComputedStyle(slideItems[0]).fontSize + ";", (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId, "font-size:0;", (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            } else if (carousel) (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        }
        // ## BASIC STYLES
        if (CSSMQ) {
            // middle wrapper style
            if (TRANSITIONDURATION) {
                var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : "";
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + "-mw", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            }
            // inner wrapper styles
            str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
            (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + "-iw", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            // container styles
            if (carousel) {
                str = horizontal && !autoWidth ? "width:" + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ";" : "";
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId, str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            }
            // slide styles
            str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : "";
            if (options.gutter) str += getSlideGutterStyle(options.gutter);
            // set gallery items transition-duration
            if (!carousel) {
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                if (ANIMATIONDURATION) str += getAnimationDurationStyle(speed);
            }
            if (str) (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // middle wrapper styles
            update_carousel_transition_duration();
            // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);
            // container styles
            if (carousel && horizontal && !autoWidth) container.style.width = getContainerWidth(fixedWidth, gutter, items);
            // slide styles
            var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : "";
            if (gutter) str += getSlideGutterStyle(gutter);
            // append to the last line
            if (str) (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
        }
        // ## MEDIAQUERIES
        if (responsive && CSSMQ) for(var bp in responsive){
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp], str = "", middleWrapperStr = "", innerWrapperStr = "", containerStr = "", slideStr = "", itemsBP = !autoWidth ? getOption("items", bp) : null, fixedWidthBP = getOption("fixedWidth", bp), speedBP = getOption("speed", bp), edgePaddingBP = getOption("edgePadding", bp), autoHeightBP = getOption("autoHeight", bp), gutterBP = getOption("gutter", bp);
            // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption("autoHeight", bp) && "speed" in opts) middleWrapperStr = "#" + slideId + "-mw{" + getTransitionDurationStyle(speedBP) + "}";
            // inner wrapper string
            if ("edgePadding" in opts || "gutter" in opts) innerWrapperStr = "#" + slideId + "-iw{" + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + "}";
            // container string
            if (carousel && horizontal && !autoWidth && ("fixedWidth" in opts || "items" in opts || fixedWidth && "gutter" in opts)) containerStr = "width:" + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ";";
            if (TRANSITIONDURATION && "speed" in opts) containerStr += getTransitionDurationStyle(speedBP);
            if (containerStr) containerStr = "#" + slideId + "{" + containerStr + "}";
            // slide string
            if ("fixedWidth" in opts || fixedWidth && "gutter" in opts || !carousel && "items" in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ("gutter" in opts) slideStr += getSlideGutterStyle(gutterBP);
            // set gallery items transition-duration
            if (!carousel && "speed" in opts) {
                if (TRANSITIONDURATION) slideStr += getTransitionDurationStyle(speedBP);
                if (ANIMATIONDURATION) slideStr += getAnimationDurationStyle(speedBP);
            }
            if (slideStr) slideStr = "#" + slideId + " > .tns-item{" + slideStr + "}";
            // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) sheet.insertRule("@media (min-width: " + bp / 16 + "em) {" + str + "}", sheet.cssRules.length);
        }
    }
    function initTools() {
        // == slides ==
        updateSlideStatus();
        // == live region ==
        outerWrapper.insertAdjacentHTML("afterbegin", '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + "</span>  of " + slideCount + "</div>");
        liveregionCurrent = outerWrapper.querySelector(".tns-liveregion .current");
        // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? "stop" : "start";
            if (autoplayButton) (0, $fc4786701fd188a9$export$7e45664a2081efb1)(autoplayButton, {
                "data-action": txt
            });
            else if (options.autoplayButtonOutput) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + "</button>");
                autoplayButton = outerWrapper.querySelector("[data-action]");
            }
            // add event
            if (autoplayButton) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(autoplayButton, {
                "click": toggleAutoplay
            });
            if (autoplay) {
                startAutoplay();
                if (autoplayHoverPause) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, hoverEvents);
                if (autoplayResetOnVisibility) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, visibilityEvent);
            }
        }
        // == navInit ==
        if (hasNav) {
            var initIndex = !carousel ? 0 : cloneCount;
            // customized nav
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navContainer, {
                    "aria-label": "Carousel Pagination"
                });
                navItems = navContainer.children;
                (0, $c4d187697d100d42$export$4b80e395e36b5a56)(navItems, function(item, i) {
                    (0, $fc4786701fd188a9$export$7e45664a2081efb1)(item, {
                        "data-nav": i,
                        "tabindex": "-1",
                        "aria-label": navStr + (i + 1),
                        "aria-controls": slideId
                    });
                });
            // generated nav
            } else {
                var navHtml = "", hiddenStr = navAsThumbnails ? "" : 'style="display:none"';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + "</div>";
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
                navContainer = outerWrapper.querySelector(".tns-nav");
                navItems = navContainer.children;
            }
            updateNavVisibility();
            // add transition
            if (TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = "transition: all " + speed / 1000 + "s";
                if (prefix) str = "-" + prefix + "-" + str;
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "[aria-controls^=" + slideId + "-item]", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            }
            (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navItems[navCurrentIndex], {
                "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(navItems[navCurrentIndex], "tabindex");
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(navItems[navCurrentIndex], navActiveClass);
            // add events
            (0, $2d450f9a54805e30$export$aadfb65bee660f96)(navContainer, navEvents);
        }
        // == controlsInit ==
        if (hasControls) {
            if (!controlsContainer && (!prevButton || !nextButton)) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + "</button></div>");
                controlsContainer = outerWrapper.querySelector(".tns-controls");
            }
            if (!prevButton || !nextButton) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            if (options.controlsContainer) (0, $fc4786701fd188a9$export$7e45664a2081efb1)(controlsContainer, {
                "aria-label": "Carousel Navigation",
                "tabindex": "0"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) (0, $fc4786701fd188a9$export$7e45664a2081efb1)([
                prevButton,
                nextButton
            ], {
                "aria-controls": slideId,
                "tabindex": "-1"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) {
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(prevButton, {
                    "data-controls": "prev"
                });
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(nextButton, {
                    "data-controls": "next"
                });
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus();
            // add events
            if (controlsContainer) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(controlsContainer, controlsEvents);
            else {
                (0, $2d450f9a54805e30$export$aadfb65bee660f96)(prevButton, controlsEvents);
                (0, $2d450f9a54805e30$export$aadfb65bee660f96)(nextButton, controlsEvents);
            }
        }
        // hide tools if needed
        disableUI();
    }
    function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, eve);
        }
        if (touch) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch);
        if (mouseDrag) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, dragEvents);
        if (arrowKeys) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(doc, docmentKeydownEvent);
        if (nested === "inner") events.on("outerResized", function() {
            resizeTasks();
            events.emit("innerLoaded", info());
        });
        else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(win, {
            "resize": onResize
        });
        if (autoHeight) {
            if (nested === "outer") events.on("innerLoaded", doAutoHeight);
            else if (!disable) doAutoHeight();
        }
        doLazyLoad();
        if (disable) disableSlider();
        else if (freeze) freezeSlider();
        events.on("indexChanged", additionalUpdates);
        if (nested === "inner") events.emit("innerLoaded", info());
        if (typeof onInit === "function") onInit(info());
        isOn = true;
    }
    function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) sheet.ownerNode.remove();
        // remove win event listeners
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(win, {
            "resize": onResize
        });
        // arrowKeys, controls, nav
        if (arrowKeys) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controlsContainer) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(controlsContainer, controlsEvents);
        if (navContainer) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(navContainer, navEvents);
        // autoplay
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, hoverEvents);
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, visibilityEvent);
        if (autoplayButton) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(autoplayButton, {
            "click": toggleAutoplay
        });
        if (autoplay) clearInterval(autoplayTimer);
        // container
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, eve);
        }
        if (touch) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, dragEvents);
        // cache Object values in options && reset HTML
        var htmlList = [
            containerHTML,
            controlsContainerHTML,
            prevButtonHTML,
            nextButtonHTML,
            navContainerHTML,
            autoplayButtonHTML
        ];
        tnsList.forEach(function(item, i) {
            var el = item === "container" ? outerWrapper : options[item];
            if (typeof el === "object" && el) {
                var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
                el.outerHTML = htmlList[i];
                options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
            }
        });
        // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
        // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });
        for(var a in this)if (a !== "rebuild") this[a] = null;
        isOn = false;
    }
    // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
        (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            resizeTasks(getEvent(e));
        });
    }
    function resizeTasks(e) {
        if (!isOn) return;
        if (nested === "outer") events.emit("outerResized", info(e));
        windowWidth = getWindowWidth();
        var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
        if (responsive) {
            setBreakpointZone();
            bpChanged = breakpointZoneTem !== breakpointZone;
            // if (hasRightDeadZone) { needContainerTransform = true; } // *?
            if (bpChanged) events.emit("newBreakpointStart", info(e));
        }
        var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
        if (bpChanged) {
            var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
            if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
        }
        // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption("arrowKeys");
        controls = getOption("controls");
        nav = getOption("nav");
        touch = getOption("touch");
        center = getOption("center");
        mouseDrag = getOption("mouseDrag");
        autoplay = getOption("autoplay");
        autoplayHoverPause = getOption("autoplayHoverPause");
        autoplayResetOnVisibility = getOption("autoplayResetOnVisibility");
        if (bpChanged) {
            disable = getOption("disable");
            fixedWidth = getOption("fixedWidth");
            speed = getOption("speed");
            autoHeight = getOption("autoHeight");
            controlsText = getOption("controlsText");
            autoplayText = getOption("autoplayText");
            autoplayTimeout = getOption("autoplayTimeout");
            if (!CSSMQ) {
                edgePadding = getOption("edgePadding");
                gutter = getOption("gutter");
            }
        }
        // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
            setSlidePositions();
            if (!horizontal) {
                updateContentWrapperHeight(); // <= setSlidePositions
                needContainerTransform = true;
            }
        }
        if (fixedWidth || autoWidth) {
            rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
            // fixedWidth: <= viewport, fixedWidth, gutter
            indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }
        if (bpChanged || fixedWidth) {
            items = getOption("items");
            slideBy = getOption("slideBy");
            itemsChanged = items !== itemsTem;
            if (itemsChanged) {
                if (!fixedWidth && !autoWidth) indexMax = getIndexMax();
                 // <= items
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
        }
        if (bpChanged) {
            if (disable !== disableTem) {
                if (disable) disableSlider();
                else enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
        }
        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
            freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
            // <= fixedWidth: fixedWidth, gutter, rightBoundary
            // <= others: items
            if (freeze !== freezeTem) {
                if (freeze) {
                    doContainerTransform(getContainerTransformValue(getStartIndex(0)));
                    freezeSlider();
                } else {
                    unfreezeSlider();
                    needContainerTransform = true;
                }
            }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) autoplayHoverPause = autoplayResetOnVisibility = false;
        if (arrowKeys !== arrowKeysTem) arrowKeys ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(doc, docmentKeydownEvent) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controls !== controlsTem) {
            if (controls) {
                if (controlsContainer) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(controlsContainer);
                else {
                    if (prevButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(prevButton);
                    if (nextButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(nextButton);
                }
            } else if (controlsContainer) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(nextButton);
            }
        }
        if (nav !== navTem) {
            if (nav) {
                (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(navContainer);
                updateNavVisibility();
            } else (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(navContainer);
        }
        if (touch !== touchTem) touch ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag !== mouseDragTem) mouseDrag ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, dragEvents) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, dragEvents);
        if (autoplay !== autoplayTem) {
            if (autoplay) {
                if (autoplayButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(autoplayButton);
                if (!animating && !autoplayUserPaused) startAutoplay();
            } else {
                if (autoplayButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(autoplayButton);
                if (animating) stopAutoplay();
            }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, hoverEvents) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, hoverEvents);
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(doc, visibilityEvent) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(doc, visibilityEvent);
        if (bpChanged) {
            if (fixedWidth !== fixedWidthTem || center !== centerTem) needContainerTransform = true;
            if (autoHeight !== autoHeightTem) {
                if (!autoHeight) innerWrapper.style.height = "";
            }
            if (controls && controlsText !== controlsTextTem) {
                prevButton.innerHTML = controlsText[0];
                nextButton.innerHTML = controlsText[1];
            }
            if (autoplayButton && autoplayText !== autoplayTextTem) {
                var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
        } else if (center && (fixedWidth || autoWidth)) needContainerTransform = true;
        if (itemsChanged || fixedWidth && !autoWidth) {
            pages = getPages();
            updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
            events.emit("indexChanged", info());
            needContainerTransform = true;
        } else if (itemsChanged) {
            if (!indChanged) additionalUpdates();
        } else if (fixedWidth || autoWidth) {
            doLazyLoad();
            updateSlideStatus();
            updateLiveRegion();
        }
        if (itemsChanged && !carousel) updateGallerySlidePositions();
        if (!disable && !freeze) {
            // non-mediaqueries: IE8
            if (bpChanged && !CSSMQ) {
                // middle wrapper styles
                // inner wrapper styles
                if (edgePadding !== edgePaddingTem || gutter !== gutterTem) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
                if (horizontal) {
                    // container styles
                    if (carousel) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                    // slide styles
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                    // remove the last line and
                    // add new styles
                    (0, $290e8f413288fb29$export$271e480b8a432c4a)(sheet, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet) - 1);
                    (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
                }
            }
            // auto height
            if (autoHeight) doAutoHeight();
            if (needContainerTransform) {
                doContainerTransformSilent();
                indexCached = index;
            }
        }
        if (bpChanged) events.emit("newBreakpointEnd", info(e));
    }
    // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
        if (!fixedWidth && !autoWidth) {
            var a = center ? items - (items - 1) / 2 : items;
            return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        return width <= vp;
    }
    function setBreakpointZone() {
        breakpointZone = 0;
        for(var bp in responsive){
            bp = parseInt(bp); // convert string to number
            if (windowWidth >= bp) breakpointZone = bp;
        }
    }
    // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? carousel ? // loop + carousel
        function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            leftEdge += slideBy;
            rightEdge -= slideBy;
            // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
                leftEdge += 1;
                rightEdge -= 1;
            } else if (fixedWidth) {
                if ((viewport + gutter) % (fixedWidth + gutter)) rightEdge -= 1;
            }
            if (cloneCount) {
                if (index > rightEdge) index -= slideCount;
                else if (index < leftEdge) index += slideCount;
            }
        } : // loop + gallery
        function() {
            if (index > indexMax) while(index >= indexMin + slideCount)index -= slideCount;
            else if (index < indexMin) while(index <= indexMax - slideCount)index += slideCount;
        } : // non-loop
        function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function disableUI() {
        if (!autoplay && autoplayButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(autoplayButton);
        if (!nav && navContainer) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(navContainer);
        if (!controls) {
            if (controlsContainer) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(nextButton);
            }
        }
    }
    function enableUI() {
        if (autoplay && autoplayButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(autoplayButton);
        if (nav && navContainer) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(navContainer);
        if (controls) {
            if (controlsContainer) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(controlsContainer);
            else {
                if (prevButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(prevButton);
                if (nextButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(nextButton);
            }
        }
    }
    function freezeSlider() {
        if (frozen) return;
        // remove edge padding from inner wrapper
        if (edgePadding) innerWrapper.style.margin = "0px";
        // add class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(slideItems[i], str);
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        disableUI();
        frozen = true;
    }
    function unfreezeSlider() {
        if (!frozen) return;
        // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) innerWrapper.style.margin = "";
        // remove class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(slideItems[i], str);
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        enableUI();
        frozen = false;
    }
    function disableSlider() {
        if (disabled) return;
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), "");
        (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(container, [
            "style"
        ]);
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(slideItems[j]);
            (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(slideItems[slideCountNew - j - 1]);
        }
        // vertical slider
        if (!horizontal || !carousel) (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(innerWrapper, [
            "style"
        ]);
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i];
            (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(item, [
                "style"
            ]);
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateIn);
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateNormal);
        }
        // update tools
        disableUI();
        disabled = true;
    }
    function enableSlider() {
        if (!disabled) return;
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(slideItems[j]);
            (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(slideItems[slideCountNew - j - 1]);
        }
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + "%";
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, classN);
        }
        // update tools
        enableUI();
        disabled = false;
    }
    function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) liveregionCurrent.innerHTML = str;
    }
    function getLiveRegionStr() {
        var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
        return start === end ? start + "" : start + " to " + end;
    }
    function getVisibleSlideRange(val) {
        if (val == null) val = getContainerTransformValue();
        var start = index, end, rangestart, rangeend;
        // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
            if (autoWidth || fixedWidth) {
                rangestart = -(parseFloat(val) + edgePadding);
                rangeend = rangestart + viewport + edgePadding * 2;
            }
        } else if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
        }
        // get start, end
        // - check auto width
        if (autoWidth) slidePositions.forEach(function(point, i) {
            if (i < slideCountNew) {
                if ((center || edgePadding) && point <= rangestart + 0.5) start = i;
                if (rangeend - point >= 0.5) end = i;
            }
        });
        else {
            if (fixedWidth) {
                var cell = fixedWidth + gutter;
                if (center || edgePadding) {
                    start = Math.floor(rangestart / cell);
                    end = Math.ceil(rangeend / cell - 1);
                } else end = start + Math.ceil(viewport / cell) - 1;
            } else if (center || edgePadding) {
                var a = items - 1;
                if (center) {
                    start -= a / 2;
                    end = index + a / 2;
                } else end = index + a;
                if (edgePadding) {
                    var b = edgePadding * items / viewport;
                    start -= b;
                    end += b;
                }
                start = Math.floor(start);
                end = Math.ceil(end);
            } else end = start + items - 1;
            start = Math.max(start, 0);
            end = Math.min(end, slideCountNew - 1);
        }
        return [
            start,
            end
        ];
    }
    function doLazyLoad() {
        if (lazyload && !disable) {
            var arg = getVisibleSlideRange();
            arg.push(lazyloadSelector);
            getImageArray.apply(null, arg).forEach(function(img) {
                if (!(0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(img, imgCompleteClass)) {
                    // stop propagation transitionend event to container
                    var eve = {};
                    eve[TRANSITIONEND] = function(e) {
                        e.stopPropagation();
                    };
                    (0, $2d450f9a54805e30$export$aadfb65bee660f96)(img, eve);
                    (0, $2d450f9a54805e30$export$aadfb65bee660f96)(img, imgEvents);
                    // update src
                    img.src = (0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(img, "data-src");
                    // update srcset
                    var srcset = (0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(img, "data-srcset");
                    if (srcset) img.srcset = srcset;
                    (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "loading");
                }
            });
        }
    }
    function onImgLoaded(e) {
        imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
        imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "loaded");
        imgCompleted(img);
    }
    function imgFailed(img) {
        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "failed");
        imgCompleted(img);
    }
    function imgCompleted(img) {
        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, imgCompleteClass);
        (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(img, "loading");
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) imgSelector = "img";
        while(start <= end){
            (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems[start].querySelectorAll(imgSelector), function(img) {
                imgs.push(img);
            });
            start++;
        }
        return imgs;
    }
    // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
    }
    function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) return cb();
        // check image classes
        imgs.forEach(function(img, index) {
            if (!lazyload && img.complete) imgCompleted(img);
             // Check image.complete
            if ((0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(img, imgCompleteClass)) imgs.splice(index, 1);
        });
        // execute callback function if selected images are all complete
        if (!imgs.length) return cb();
        // otherwise execute this functiona again
        (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, cb);
        });
    }
    function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
    }
    function update_carousel_transition_duration() {
        if (carousel && autoHeight) middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + "s";
    }
    function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for(var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++)heights.push(slideItems[i].offsetHeight);
        return Math.max.apply(null, heights);
    }
    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) wp.style.height = maxHeight + "px";
    }
    // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
        slidePositions = [
            0
        ];
        var attr = horizontal ? "left" : "top", attr2 = horizontal ? "right" : "bottom", base = slideItems[0].getBoundingClientRect()[attr];
        (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // skip the first slide
            if (i) slidePositions.push(item.getBoundingClientRect()[attr] - base);
            // add the end edge
            if (i === slideCountNew - 1) slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        });
    }
    // update slide
    function updateSlideStatus() {
        var range = getVisibleSlideRange(), start = range[0], end = range[1];
        (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // show slides
            if (i >= start && i <= end) {
                if ((0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(item, "aria-hidden")) {
                    (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(item, [
                        "aria-hidden",
                        "tabindex"
                    ]);
                    (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, slideActiveClass);
                }
            } else if (!(0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(item, "aria-hidden")) {
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(item, {
                    "aria-hidden": "true",
                    "tabindex": "-1"
                });
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, slideActiveClass);
            }
        });
    }
    // gallery: update slide position
    function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            if (i >= index && i < l) {
                // add transitions to visible slides when adjusting their positions
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, "tns-moving");
                item.style.left = (i - index) * 100 / items + "%";
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateIn);
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateNormal);
            } else if (item.style.left) {
                item.style.left = "";
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateNormal);
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateIn);
            }
            // remove outlet animation
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateOut);
        }
        // removing '.tns-moving'
        setTimeout(function() {
            (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(el) {
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(el, "tns-moving");
            });
        }, 300);
    }
    // set tabindex on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navPrev, {
                    "tabindex": "-1",
                    "aria-label": navStr + (navCurrentIndexCached + 1)
                });
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(navPrev, navActiveClass);
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navCurrent, {
                    "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
                });
                (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(navCurrent, "tabindex");
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(navCurrent, navActiveClass);
                navCurrentIndexCached = navCurrentIndex;
            }
        }
    }
    function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
    }
    function isButton(el) {
        return getLowerCaseNodeName(el) === "button";
    }
    function isAriaDisabled(el) {
        return el.getAttribute("aria-disabled") === "true";
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute("aria-disabled", val.toString());
    }
    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    }
    // set duration
    function resetDuration(el, str) {
        if (TRANSITIONDURATION) el.style[TRANSITIONDURATION] = str;
    }
    function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
        if (num == null) num = index;
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
        var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
        if (center && !loop) result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        if (result > 0) result = 0;
        return result;
    }
    function getContainerTransformValue(num) {
        if (num == null) num = index;
        var val;
        if (horizontal && !autoWidth) {
            if (fixedWidth) {
                val = -(fixedWidth + gutter) * num;
                if (center) val += getCenterGap();
            } else {
                var denominator = TRANSFORM ? slideCountNew : items;
                if (center) num -= getCenterGap();
                val = -num * 100 / denominator;
            }
        } else {
            val = -slidePositions[num];
            if (center && autoWidth) val += getCenterGap();
        }
        if (hasRightDeadZone) val = Math.max(val, rightBoundary);
        val += horizontal && !autoWidth && !fixedWidth ? "%" : "px";
        return val;
    }
    function doContainerTransformSilent(val) {
        resetDuration(container, "0s");
        doContainerTransform(val);
    }
    function doContainerTransform(val) {
        if (val == null) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) l = Math.min(l, slideCountNew);
        for(var i = number; i < l; i++){
            var item = slideItems[i];
            // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + "%";
            if (animateDelay && TRANSITIONDELAY) item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + "s";
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, classOut);
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    }
    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function() {
            resetDuration(container, "");
            if (TRANSITIONDURATION || !speed) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform();
                // run fallback function manually
                // when duration is 0 / container is hidden
                if (!speed || !(0, $807f43eecb4b0d07$export$795910f5f15a9633)(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            (0, $9e1eeb371de7034f$export$e2705a83c013f564)(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function() {
            slideItemsOut = [];
            var eve = {};
            eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
            (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(slideItems[indexCached], eve);
            (0, $2d450f9a54805e30$export$aadfb65bee660f96)(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn);
            // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!TRANSITIONEND || !ANIMATIONEND || !speed || !(0, $807f43eecb4b0d07$export$795910f5f15a9633)(container)) onTransitionEnd();
        };
    }();
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit("indexChanged", info());
            events.emit("transitionStart", info());
            if (autoHeight) doAutoHeight();
            // pause autoplay when click or keydown from user
            if (animating && e && [
                "click",
                "keydown"
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            transformCore();
        }
    }
    /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, "");
    }
    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit("transitionEnd", info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < slideItemsOut.length; i++){
                var item = slideItemsOut[i];
                // set item positions
                item.style.left = "";
                if (ANIMATIONDELAY && TRANSITIONDELAY) {
                    item.style[ANIMATIONDELAY] = "";
                    item.style[TRANSITIONDELAY] = "";
                }
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateOut);
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit("indexChanged", info());
                        doContainerTransformSilent();
                    }
                }
                if (nested === "inner") events.emit("innerLoaded", info());
                running = false;
                indexCached = index;
            }
        }
    }
    // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
        // prev slideBy
        if (targetIndex === "prev") onControlsClick(e, -1);
        else if (targetIndex === "next") onControlsClick(e, 1);
        else {
            if (running) {
                if (preventActionWhenRunning) return;
                else onTransitionEnd();
            }
            var absIndex = getAbsIndex(), indexGap = 0;
            if (targetIndex === "first") indexGap = -absIndex;
            else if (targetIndex === "last") indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
            else {
                if (typeof targetIndex !== "number") targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    // from directly called goTo function
                    if (!e) targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
                    indexGap = targetIndex - absIndex;
                }
            }
            // gallery: make sure new page won't overlap with current page
            if (!carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
            }
            index += indexGap;
            // make sure index is in range
            if (carousel && loop) {
                if (index < indexMin) index += slideCount;
                if (index > indexMax) index -= slideCount;
            }
            // if index is changed, start rendering
            if (getAbsIndex(index) !== getAbsIndex(indexCached)) render(e);
        }
    }
    // on controls click
    function onControlsClick(e, dir) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        var passEventObject;
        if (!dir) {
            e = getEvent(e);
            var target = getTarget(e);
            while(target !== controlsContainer && [
                prevButton,
                nextButton
            ].indexOf(target) < 0)target = target.parentNode;
            var targetIn = [
                prevButton,
                nextButton
            ].indexOf(target);
            if (targetIn >= 0) {
                passEventObject = true;
                dir = targetIn === 0 ? -1 : 1;
            }
        }
        if (rewind) {
            if (index === indexMin && dir === -1) {
                goTo("last", e);
                return;
            } else if (index === indexMax && dir === 1) {
                goTo("first", e);
                return;
            }
        }
        if (dir) {
            index += slideBy * dir;
            if (autoWidth) index = Math.floor(index);
            // pass e when click control buttons or keydown
            render(passEventObject || e && e.type === "keydown" ? e : null);
        }
    }
    // on nav click
    function onNavClick(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        e = getEvent(e);
        var target = getTarget(e), navIndex;
        // find the clicked nav item
        while(target !== navContainer && !(0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(target, "data-nav"))target = target.parentNode;
        if ((0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(target, "data-nav")) {
            var navIndex = navClicked = Number((0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(target, "data-nav")), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
            goTo(targetIndex, e);
            if (navCurrentIndex === navIndex) {
                if (animating) stopAutoplay();
                navClicked = -1; // reset navClicked
            }
        }
    }
    // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        (0, $fc4786701fd188a9$export$7e45664a2081efb1)(autoplayButton, {
            "data-action": action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("stop", autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("start", autoplayText[0]);
    }
    // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function pause() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        }
    }
    function toggleAutoplay() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        } else {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function onVisibilityChange() {
        if (doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    }
    // keydown events on document
    function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) onControlsClick(e, keyIndex === 0 ? -1 : 1);
    }
    // on key control
    function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (!prevButton.disabled) onControlsClick(e, -1);
            } else if (!nextButton.disabled) onControlsClick(e, 1);
        }
    }
    // set focus
    function setFocus(el) {
        el.focus();
    }
    // on key nav
    function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!(0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(curElement, "data-nav")) return;
        // var code = e.keyCode,
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT,
            KEYS.ENTER,
            KEYS.SPACE
        ].indexOf(e.keyCode), navIndex = Number((0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(curElement, "data-nav"));
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (navIndex > 0) setFocus(navItems[navIndex - 1]);
            } else if (keyIndex === 1) {
                if (navIndex < pages - 1) setFocus(navItems[navIndex + 1]);
            } else {
                navClicked = navIndex;
                goTo(navIndex, e);
            }
        }
    }
    function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
        return e.target || win.event.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf("touch") >= 0;
    }
    function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
        return (0, $c56a54e7f265475e$export$83b6d73568c72b60)((0, $d546b5ddaa1f720a$export$c796d9d3e501591f)(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        if (autoplay && animating) stopAutoplayTimer();
        panStart = true;
        if (rafIndex) {
            (0, $9960623eeb62d695$export$75aab3dbee8deceb)(rafIndex);
            rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? "touchStart" : "dragStart", info(e));
        if (!isTouchEvent(e) && [
            "img",
            "a"
        ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) preventDefaultBehavior(e);
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ""));
            resetDuration(container, "0s");
        }
    }
    function onPanMove(e) {
        if (panStart) {
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            if (carousel) {
                if (!rafIndex) rafIndex = (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                    panUpdate(e);
                });
            } else {
                if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
                if (moveDirectionExpected) preventScroll = true;
            }
            if ((typeof e.cancelable !== "boolean" || e.cancelable) && preventScroll) e.preventDefault();
        }
    }
    function panUpdate(e) {
        if (!moveDirectionExpected) {
            panStart = false;
            return;
        }
        (0, $9960623eeb62d695$export$75aab3dbee8deceb)(rafIndex);
        if (panStart) rafIndex = (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            panUpdate(e);
        });
        if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
        if (moveDirectionExpected) {
            if (!preventScroll && isTouchEvent(e)) preventScroll = true;
            try {
                if (e.type) events.emit(isTouchEvent(e) ? "touchMove" : "dragMove", info(e));
            } catch (err) {}
            var x = translateInit, dist = getDist(lastPosition, initPosition);
            if (!horizontal || fixedWidth || autoWidth) {
                x += dist;
                x += "px";
            } else {
                var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
                x += percentageX;
                x += "%";
            }
            container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
    }
    function onPanEnd(e) {
        if (panStart) {
            if (rafIndex) {
                (0, $9960623eeb62d695$export$75aab3dbee8deceb)(rafIndex);
                rafIndex = null;
            }
            if (carousel) resetDuration(container, "");
            panStart = false;
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            var dist = getDist(lastPosition, initPosition);
            if (Math.abs(dist)) {
                // drag vs click
                if (!isTouchEvent(e)) {
                    // prevent "click"
                    var target = getTarget(e);
                    (0, $2d450f9a54805e30$export$aadfb65bee660f96)(target, {
                        "click": function preventClick(e) {
                            preventDefaultBehavior(e);
                            (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(target, {
                                "click": preventClick
                            });
                        }
                    });
                }
                if (carousel) rafIndex = (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                    if (horizontal && !autoWidth) {
                        var indexMoved = -dist * items / (viewport + gutter);
                        indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                        index += indexMoved;
                    } else {
                        var moved = -(translateInit + dist);
                        if (moved <= 0) index = indexMin;
                        else if (moved >= slidePositions[slideCountNew - 1]) index = indexMax;
                        else {
                            var i = 0;
                            while(i < slideCountNew && moved >= slidePositions[i]){
                                index = i;
                                if (moved > slidePositions[i] && dist < 0) index += 1;
                                i++;
                            }
                        }
                    }
                    render(e, dist);
                    events.emit(isTouchEvent(e) ? "touchEnd" : "dragEnd", info(e));
                });
                else if (moveDirectionExpected) onControlsClick(e, dist > 0 ? -1 : 1);
            }
        }
        // reset
        if (options.preventScrollOnTouch === "auto") preventScroll = false;
        if (swipeAngle) moveDirectionExpected = "?";
        if (autoplay && !animating) setAutoplayTimer();
    }
    // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + "px";
    }
    function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
    }
    /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        if (pages !== pagesCached) {
            var min = pagesCached, max = pages, fn = (0, $7e4aafbbd7b5f772$export$998191bfdf710c72);
            if (pagesCached > pages) {
                min = pages;
                max = pagesCached;
                fn = (0, $b6b059ab1be1bedb$export$7669482c90f5c50f);
            }
            while(min < max){
                fn(navItems[min]);
                min++;
            }
            // cache pages
            pagesCached = pages;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            displayIndex: getCurrentSlide(),
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            pages: pages,
            pagesCached: pagesCached,
            sheet: sheet,
            isOn: isOn,
            event: e || {}
        };
    }
    return {
        version: "2.9.4",
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function rebuild() {
            return $665047dee130590c$export$51fe319e24d9d8c9((0, $8def800bd2c631ba$export$8b58be045bf06082)(options, optionsElements));
        }
    };
};


// POSSIBLE OPTIONS
// Also find more documentation here: http://ganlanyuan.github.io/tiny-slider/demo/
var $090fc41b963e5410$var$default_options = {
    //     container: '.slider',
    //     mode: 'carousel',
    //     axis: 'horizontal',
    items: 1,
    //     gutter: 0,
    //     edgePadding: 0,
    //     fixedWidth: false,
    //     autoWidth: false,
    //     viewportMax: false,
    // 	   slideBy: 2,
    //     center: false,
    controls: false,
    //     controlsPosition: 'top',
    //     controlsText: ['prev', 'next'],
    //     controlsContainer: false,
    //     prevButton: false,
    //     nextButton: false,
    nav: true,
    navPosition: "bottom",
    //     navContainer: false,
    //     navAsThumbnails: false,
    //     arrowKeys: false,
    //     speed: 300,
    autoplay: false,
    //     autoplayPosition: 'top',
    autoplayTimeout: 5000,
    //     autoplayDirection: 'forward',
    //     autoplayText: ['start', 'stop'],
    //     autoplayHoverPause: false,
    //     autoplayButton: false,
    //     autoplayButtonOutput: true,
    //     autoplayResetOnVisibility: true,
    //     animateIn: 'tns-fadeIn',
    //     animateOut: 'tns-fadeOut',
    //     animateNormal: 'tns-normal',
    //     animateDelay: false,
    loop: true,
    //     rewind: false,
    autoHeight: true,
    //     responsive: false,
    //     lazyload: false,
    //     lazyloadSelector: '.tns-lazy-img',
    //     touch: true,
    mouseDrag: true
};
function $090fc41b963e5410$export$2e2bcd8739ae039() {
    var sliders = $090fc41b963e5410$var$getSliders([
        "[data-slider]"
    ]);
    var result = {};
    if (!sliders) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sliders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var slider = _step.value;
            name = $090fc41b963e5410$var$getSliderName(slider);
            result[name] = $090fc41b963e5410$var$initSlider(slider);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $090fc41b963e5410$var$getSliders(selector) {
    return document.querySelectorAll(selector);
}
function $090fc41b963e5410$var$getSliderElements(name1) {
    var elements = {
        prevButton: document.querySelector('[data-slider-prev="' + name1 + '"]'),
        nextButton: document.querySelector('[data-slider-next="' + name1 + '"]'),
        counter: document.querySelector('[data-slider-counter="' + name1 + '"]')
    };
    console.log(elements);
    if (elements.prevButton != null || elements.nextButton != null) elements.controls = true;
    console.log(elements);
    return elements;
}
function $090fc41b963e5410$var$getSliderOptions(slider) {
    return JSON.parse(slider.getAttribute("data-slider-options"));
}
function $090fc41b963e5410$var$getSliderName(slider) {
    return slider.getAttribute("data-slider");
}
function $090fc41b963e5410$var$configSlider(slider) {
    var name1 = $090fc41b963e5410$var$getSliderName(slider);
    var config = $090fc41b963e5410$var$default_options;
    var elements = $090fc41b963e5410$var$getSliderElements(name1);
    if (elements) config = Object.assign(config, elements);
    var options = $090fc41b963e5410$var$getSliderOptions(slider);
    if (options) config = Object.assign(config, options);
    config = Object.assign(config, {
        "container": slider
    });
    return config;
}
// Hero slider
function $090fc41b963e5410$var$initSlider(element) {
    var config = $090fc41b963e5410$var$configSlider(element);
    var slider = (0, $665047dee130590c$export$51fe319e24d9d8c9)(config);
    var sliderCounter = config.counter;
    slider.events.on("indexChanged", function(info, eventName) {
        console.log(info);
        if (sliderCounter) {
            var newValue = info.displayIndex + " / " + info.slideCount;
            $090fc41b963e5410$var$updateCounter(sliderCounter, newValue);
        }
    });
    return slider;
}
function $090fc41b963e5410$var$updateCounter(counter, newValue) {
    counter.innerText = newValue;
}



function $2c075c4f8abccf04$export$6ce6338c63a1fc84(name, parent) {
    var slider;
    if (name && parent) {
        var element = parent.querySelector('[data-slider="' + name + '"]');
        var prev = parent.querySelector('[data-slider-prev="' + name + '"]');
        var next = parent.querySelector('[data-slider-next="' + name + '"]');
        // don't start function if the element is not on the page
        if (!element) return;
        slider = (0, $665047dee130590c$export$51fe319e24d9d8c9)({
            container: element,
            items: 1,
            slideBy: 1,
            mouseDrag: true,
            autoplay: true,
            autoplayTimeout: 2000,
            controls: true,
            nav: false,
            autoplayButtonOutput: false,
            prevButton: prev,
            nextButton: next,
            gutter: 0,
            loop: false,
            edgePadding: 0,
            responsive: {
                0: {
                    items: 1
                },
                992: {
                    items: 1
                }
            }
        });
    } else {
        console.log("missing Name or Container parameter");
        return "missing Name or Container parameter";
    }
    return slider;
}


function $1968e3edfc5cfc11$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $7a9bc48c6110351f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7a9bc48c6110351f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7a9bc48c6110351f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7a9bc48c6110351f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $7a9bc48c6110351f$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $7a9bc48c6110351f$var$CREATED = 1;
var $7a9bc48c6110351f$var$MOUNTED = 2;
var $7a9bc48c6110351f$var$IDLE = 3;
var $7a9bc48c6110351f$var$MOVING = 4;
var $7a9bc48c6110351f$var$SCROLLING = 5;
var $7a9bc48c6110351f$var$DRAGGING = 6;
var $7a9bc48c6110351f$var$DESTROYED = 7;
var $7a9bc48c6110351f$var$STATES = {
    CREATED: $7a9bc48c6110351f$var$CREATED,
    MOUNTED: $7a9bc48c6110351f$var$MOUNTED,
    IDLE: $7a9bc48c6110351f$var$IDLE,
    MOVING: $7a9bc48c6110351f$var$MOVING,
    SCROLLING: $7a9bc48c6110351f$var$SCROLLING,
    DRAGGING: $7a9bc48c6110351f$var$DRAGGING,
    DESTROYED: $7a9bc48c6110351f$var$DESTROYED
};
function $7a9bc48c6110351f$var$empty(array) {
    array.length = 0;
}
function $7a9bc48c6110351f$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $7a9bc48c6110351f$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($7a9bc48c6110351f$var$slice(arguments, 1)));
}
var $7a9bc48c6110351f$var$nextTick = setTimeout;
var $7a9bc48c6110351f$var$noop = function noop() {};
function $7a9bc48c6110351f$var$raf(func) {
    return requestAnimationFrame(func);
}
function $7a9bc48c6110351f$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$5f0017c582d45a2d)(subject)) === type;
}
function $7a9bc48c6110351f$var$isObject(subject) {
    return !$7a9bc48c6110351f$var$isNull(subject) && $7a9bc48c6110351f$var$typeOf("object", subject);
}
var $7a9bc48c6110351f$var$isArray = Array.isArray;
var $7a9bc48c6110351f$var$isFunction = $7a9bc48c6110351f$var$apply($7a9bc48c6110351f$var$typeOf, "function");
var $7a9bc48c6110351f$var$isString = $7a9bc48c6110351f$var$apply($7a9bc48c6110351f$var$typeOf, "string");
var $7a9bc48c6110351f$var$isUndefined = $7a9bc48c6110351f$var$apply($7a9bc48c6110351f$var$typeOf, "undefined");
function $7a9bc48c6110351f$var$isNull(subject) {
    return subject === null;
}
function $7a9bc48c6110351f$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $7a9bc48c6110351f$var$toArray(value) {
    return $7a9bc48c6110351f$var$isArray(value) ? value : [
        value
    ];
}
function $7a9bc48c6110351f$var$forEach(values, iteratee) {
    $7a9bc48c6110351f$var$toArray(values).forEach(iteratee);
}
function $7a9bc48c6110351f$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $7a9bc48c6110351f$var$push(array, items) {
    array.push.apply(array, $7a9bc48c6110351f$var$toArray(items));
    return array;
}
function $7a9bc48c6110351f$var$toggleClass(elm, classes, add) {
    if (elm) $7a9bc48c6110351f$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $7a9bc48c6110351f$var$addClass(elm, classes) {
    $7a9bc48c6110351f$var$toggleClass(elm, $7a9bc48c6110351f$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $7a9bc48c6110351f$var$append(parent, children) {
    $7a9bc48c6110351f$var$forEach(children, parent.appendChild.bind(parent));
}
function $7a9bc48c6110351f$var$before(nodes, ref) {
    $7a9bc48c6110351f$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $7a9bc48c6110351f$var$matches(elm, selector) {
    return $7a9bc48c6110351f$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $7a9bc48c6110351f$var$children(parent, selector) {
    var children2 = parent ? $7a9bc48c6110351f$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $7a9bc48c6110351f$var$matches(child, selector);
    }) : children2;
}
function $7a9bc48c6110351f$var$child(parent, selector) {
    return selector ? $7a9bc48c6110351f$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $7a9bc48c6110351f$var$ownKeys = Object.keys;
function $7a9bc48c6110351f$var$forOwn(object, iteratee, right) {
    if (object) (right ? $7a9bc48c6110351f$var$ownKeys(object).reverse() : $7a9bc48c6110351f$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $7a9bc48c6110351f$var$assign(object) {
    $7a9bc48c6110351f$var$slice(arguments, 1).forEach(function(source) {
        $7a9bc48c6110351f$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $7a9bc48c6110351f$var$merge(object) {
    $7a9bc48c6110351f$var$slice(arguments, 1).forEach(function(source) {
        $7a9bc48c6110351f$var$forOwn(source, function(value, key) {
            if ($7a9bc48c6110351f$var$isArray(value)) object[key] = value.slice();
            else if ($7a9bc48c6110351f$var$isObject(value)) object[key] = $7a9bc48c6110351f$var$merge({}, $7a9bc48c6110351f$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $7a9bc48c6110351f$var$omit(object, keys) {
    $7a9bc48c6110351f$var$forEach(keys || $7a9bc48c6110351f$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $7a9bc48c6110351f$var$removeAttribute(elms, attrs) {
    $7a9bc48c6110351f$var$forEach(elms, function(elm) {
        $7a9bc48c6110351f$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $7a9bc48c6110351f$var$setAttribute(elms, attrs, value) {
    if ($7a9bc48c6110351f$var$isObject(attrs)) $7a9bc48c6110351f$var$forOwn(attrs, function(value2, name) {
        $7a9bc48c6110351f$var$setAttribute(elms, name, value2);
    });
    else $7a9bc48c6110351f$var$forEach(elms, function(elm) {
        $7a9bc48c6110351f$var$isNull(value) || value === "" ? $7a9bc48c6110351f$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $7a9bc48c6110351f$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $7a9bc48c6110351f$var$isString(attrs) ? $7a9bc48c6110351f$var$addClass(elm, attrs) : $7a9bc48c6110351f$var$setAttribute(elm, attrs);
    parent && $7a9bc48c6110351f$var$append(parent, elm);
    return elm;
}
function $7a9bc48c6110351f$var$style(elm, prop, value) {
    if ($7a9bc48c6110351f$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$7a9bc48c6110351f$var$isNull(value)) elm.style[prop] = "" + value;
}
function $7a9bc48c6110351f$var$display(elm, display2) {
    $7a9bc48c6110351f$var$style(elm, "display", display2);
}
function $7a9bc48c6110351f$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $7a9bc48c6110351f$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $7a9bc48c6110351f$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $7a9bc48c6110351f$var$rect(target) {
    return target.getBoundingClientRect();
}
function $7a9bc48c6110351f$var$remove(nodes) {
    $7a9bc48c6110351f$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $7a9bc48c6110351f$var$parseHtml(html) {
    return $7a9bc48c6110351f$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $7a9bc48c6110351f$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $7a9bc48c6110351f$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $7a9bc48c6110351f$var$queryAll(parent, selector) {
    return selector ? $7a9bc48c6110351f$var$slice(parent.querySelectorAll(selector)) : [];
}
function $7a9bc48c6110351f$var$removeClass(elm, classes) {
    $7a9bc48c6110351f$var$toggleClass(elm, classes, false);
}
function $7a9bc48c6110351f$var$timeOf(e) {
    return e.timeStamp;
}
function $7a9bc48c6110351f$var$unit(value) {
    return $7a9bc48c6110351f$var$isString(value) ? value : value ? value + "px" : "";
}
var $7a9bc48c6110351f$var$PROJECT_CODE = "splide";
var $7a9bc48c6110351f$var$DATA_ATTRIBUTE = "data-" + $7a9bc48c6110351f$var$PROJECT_CODE;
function $7a9bc48c6110351f$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $7a9bc48c6110351f$var$PROJECT_CODE + "] " + (message || ""));
}
var $7a9bc48c6110351f$var$min = Math.min, $7a9bc48c6110351f$var$max = Math.max, $7a9bc48c6110351f$var$floor = Math.floor, $7a9bc48c6110351f$var$ceil = Math.ceil, $7a9bc48c6110351f$var$abs = Math.abs;
function $7a9bc48c6110351f$var$approximatelyEqual(x, y, epsilon) {
    return $7a9bc48c6110351f$var$abs(x - y) < epsilon;
}
function $7a9bc48c6110351f$var$between(number, x, y, exclusive) {
    var minimum = $7a9bc48c6110351f$var$min(x, y);
    var maximum = $7a9bc48c6110351f$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $7a9bc48c6110351f$var$clamp(number, x, y) {
    var minimum = $7a9bc48c6110351f$var$min(x, y);
    var maximum = $7a9bc48c6110351f$var$max(x, y);
    return $7a9bc48c6110351f$var$min($7a9bc48c6110351f$var$max(minimum, number), maximum);
}
function $7a9bc48c6110351f$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $7a9bc48c6110351f$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $7a9bc48c6110351f$var$format(string, replacements) {
    $7a9bc48c6110351f$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $7a9bc48c6110351f$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $7a9bc48c6110351f$var$ids = {};
function $7a9bc48c6110351f$var$uniqueId(prefix) {
    return "" + prefix + $7a9bc48c6110351f$var$pad($7a9bc48c6110351f$var$ids[prefix] = ($7a9bc48c6110351f$var$ids[prefix] || 0) + 1);
}
function $7a9bc48c6110351f$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $7a9bc48c6110351f$var$forEach(targets, function(target) {
            target && $7a9bc48c6110351f$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $7a9bc48c6110351f$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $7a9bc48c6110351f$export$d300dc1a2634364b = "mounted";
var $7a9bc48c6110351f$export$d8dac49b4532735a = "ready";
var $7a9bc48c6110351f$export$2aa493d7c3275167 = "move";
var $7a9bc48c6110351f$export$fe5802204b967f0d = "moved";
var $7a9bc48c6110351f$export$5adb665701eda1ce = "click";
var $7a9bc48c6110351f$export$92e3eae133acac4c = "active";
var $7a9bc48c6110351f$export$6bcbb81035c12cea = "inactive";
var $7a9bc48c6110351f$export$6a5b3445e4066a53 = "visible";
var $7a9bc48c6110351f$export$8c5c7a21d54563e9 = "hidden";
var $7a9bc48c6110351f$export$7f4701ac5e05e39f = "refresh";
var $7a9bc48c6110351f$export$db40ab7c0855fa5c = "updated";
var $7a9bc48c6110351f$export$7e019dae5103a285 = "resize";
var $7a9bc48c6110351f$export$d637eba1e9e28482 = "resized";
var $7a9bc48c6110351f$export$e84bf5065c9087ac = "drag";
var $7a9bc48c6110351f$export$8e9f636d2c722196 = "dragging";
var $7a9bc48c6110351f$export$90ea576bd3fdeb60 = "dragged";
var $7a9bc48c6110351f$export$49801896908b5e33 = "scroll";
var $7a9bc48c6110351f$export$ff8164bff3202b9 = "scrolled";
var $7a9bc48c6110351f$export$6cbac5b662a31e1b = "overflow";
var $7a9bc48c6110351f$export$88c4cf7419e470cd = "destroy";
var $7a9bc48c6110351f$export$8647f6b043e04e9d = "arrows:mounted";
var $7a9bc48c6110351f$export$d467f9343b961f75 = "arrows:updated";
var $7a9bc48c6110351f$export$bf89a4e4349c9778 = "pagination:mounted";
var $7a9bc48c6110351f$export$eb2019082ed6de0b = "pagination:updated";
var $7a9bc48c6110351f$export$84015c33508f94ec = "navigation:mounted";
var $7a9bc48c6110351f$export$23663268a31b79e2 = "autoplay:play";
var $7a9bc48c6110351f$export$185723258309b608 = "autoplay:playing";
var $7a9bc48c6110351f$export$16a1e4f3d0368265 = "autoplay:pause";
var $7a9bc48c6110351f$export$9f64346e17f0ec8e = "lazyload:loaded";
var $7a9bc48c6110351f$export$6d5af59619d10e6a = "sk";
var $7a9bc48c6110351f$export$f0af896383d5adff = "sh";
var $7a9bc48c6110351f$export$28dea85f216954dc = "ei";
function $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $7a9bc48c6110351f$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $7a9bc48c6110351f$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $7a9bc48c6110351f$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $7a9bc48c6110351f$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($7a9bc48c6110351f$export$88c4cf7419e470cd, binder.destroy);
    return $7a9bc48c6110351f$var$assign(binder, {
        bus: bus,
        on: on,
        off: $7a9bc48c6110351f$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $7a9bc48c6110351f$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $7a9bc48c6110351f$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $7a9bc48c6110351f$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $7a9bc48c6110351f$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $7a9bc48c6110351f$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $7a9bc48c6110351f$var$includes($7a9bc48c6110351f$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $7a9bc48c6110351f$export$efff0f5979573c99(func, duration) {
    var interval = $7a9bc48c6110351f$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $7a9bc48c6110351f$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $7a9bc48c6110351f$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $7a9bc48c6110351f$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $7a9bc48c6110351f$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($7a9bc48c6110351f$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $7a9bc48c6110351f$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $7a9bc48c6110351f$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($7a9bc48c6110351f$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $7a9bc48c6110351f$var$merge(options, reducedMotion) : $7a9bc48c6110351f$var$omit(options, $7a9bc48c6110351f$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $7a9bc48c6110351f$var$merge(options, opts);
        base && $7a9bc48c6110351f$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($7a9bc48c6110351f$var$CREATED)) Splide2.emit($7a9bc48c6110351f$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $7a9bc48c6110351f$var$ARROW = "Arrow";
var $7a9bc48c6110351f$var$ARROW_LEFT = $7a9bc48c6110351f$var$ARROW + "Left";
var $7a9bc48c6110351f$var$ARROW_RIGHT = $7a9bc48c6110351f$var$ARROW + "Right";
var $7a9bc48c6110351f$var$ARROW_UP = $7a9bc48c6110351f$var$ARROW + "Up";
var $7a9bc48c6110351f$var$ARROW_DOWN = $7a9bc48c6110351f$var$ARROW + "Down";
var $7a9bc48c6110351f$export$373e92e0788ff06e = "ltr";
var $7a9bc48c6110351f$export$850f7749a2909601 = "rtl";
var $7a9bc48c6110351f$export$97170d9824b89709 = "ttb";
var $7a9bc48c6110351f$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $7a9bc48c6110351f$var$ARROW_UP,
        $7a9bc48c6110351f$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $7a9bc48c6110351f$var$ARROW_DOWN,
        $7a9bc48c6110351f$var$ARROW_LEFT
    ]
};
function $7a9bc48c6110351f$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $7a9bc48c6110351f$export$850f7749a2909601 && !axisOnly ? 1 : direction === $7a9bc48c6110351f$export$97170d9824b89709 ? 0 : -1;
        return $7a9bc48c6110351f$var$ORIENTATION_MAP[prop] && $7a9bc48c6110351f$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $7a9bc48c6110351f$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $7a9bc48c6110351f$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $7a9bc48c6110351f$var$ROLE = "role";
var $7a9bc48c6110351f$var$TAB_INDEX = "tabindex";
var $7a9bc48c6110351f$var$DISABLED = "disabled";
var $7a9bc48c6110351f$var$ARIA_PREFIX = "aria-";
var $7a9bc48c6110351f$var$ARIA_CONTROLS = $7a9bc48c6110351f$var$ARIA_PREFIX + "controls";
var $7a9bc48c6110351f$var$ARIA_CURRENT = $7a9bc48c6110351f$var$ARIA_PREFIX + "current";
var $7a9bc48c6110351f$var$ARIA_SELECTED = $7a9bc48c6110351f$var$ARIA_PREFIX + "selected";
var $7a9bc48c6110351f$var$ARIA_LABEL = $7a9bc48c6110351f$var$ARIA_PREFIX + "label";
var $7a9bc48c6110351f$var$ARIA_LABELLEDBY = $7a9bc48c6110351f$var$ARIA_PREFIX + "labelledby";
var $7a9bc48c6110351f$var$ARIA_HIDDEN = $7a9bc48c6110351f$var$ARIA_PREFIX + "hidden";
var $7a9bc48c6110351f$var$ARIA_ORIENTATION = $7a9bc48c6110351f$var$ARIA_PREFIX + "orientation";
var $7a9bc48c6110351f$var$ARIA_ROLEDESCRIPTION = $7a9bc48c6110351f$var$ARIA_PREFIX + "roledescription";
var $7a9bc48c6110351f$var$ARIA_LIVE = $7a9bc48c6110351f$var$ARIA_PREFIX + "live";
var $7a9bc48c6110351f$var$ARIA_BUSY = $7a9bc48c6110351f$var$ARIA_PREFIX + "busy";
var $7a9bc48c6110351f$var$ARIA_ATOMIC = $7a9bc48c6110351f$var$ARIA_PREFIX + "atomic";
var $7a9bc48c6110351f$var$ALL_ATTRIBUTES = [
    $7a9bc48c6110351f$var$ROLE,
    $7a9bc48c6110351f$var$TAB_INDEX,
    $7a9bc48c6110351f$var$DISABLED,
    $7a9bc48c6110351f$var$ARIA_CONTROLS,
    $7a9bc48c6110351f$var$ARIA_CURRENT,
    $7a9bc48c6110351f$var$ARIA_LABEL,
    $7a9bc48c6110351f$var$ARIA_LABELLEDBY,
    $7a9bc48c6110351f$var$ARIA_HIDDEN,
    $7a9bc48c6110351f$var$ARIA_ORIENTATION,
    $7a9bc48c6110351f$var$ARIA_ROLEDESCRIPTION
];
var $7a9bc48c6110351f$var$CLASS_PREFIX = $7a9bc48c6110351f$var$PROJECT_CODE + "__";
var $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX = "is-";
var $7a9bc48c6110351f$export$93b21159ad85c843 = $7a9bc48c6110351f$var$PROJECT_CODE;
var $7a9bc48c6110351f$export$7738b09ac0a98952 = $7a9bc48c6110351f$var$CLASS_PREFIX + "track";
var $7a9bc48c6110351f$export$19cc2a5451235cae = $7a9bc48c6110351f$var$CLASS_PREFIX + "list";
var $7a9bc48c6110351f$export$8d922915837a38d3 = $7a9bc48c6110351f$var$CLASS_PREFIX + "slide";
var $7a9bc48c6110351f$export$2c1ba4a4f1aa4947 = $7a9bc48c6110351f$export$8d922915837a38d3 + "--clone";
var $7a9bc48c6110351f$export$e9ba7e444ba60a12 = $7a9bc48c6110351f$export$8d922915837a38d3 + "__container";
var $7a9bc48c6110351f$export$a26cbd955fecf11e = $7a9bc48c6110351f$var$CLASS_PREFIX + "arrows";
var $7a9bc48c6110351f$export$516e7d18e13a2dca = $7a9bc48c6110351f$var$CLASS_PREFIX + "arrow";
var $7a9bc48c6110351f$export$58ea3db24c33b76 = $7a9bc48c6110351f$export$516e7d18e13a2dca + "--prev";
var $7a9bc48c6110351f$export$4885afd7098a65c2 = $7a9bc48c6110351f$export$516e7d18e13a2dca + "--next";
var $7a9bc48c6110351f$export$cbf8e5a0ab95eda3 = $7a9bc48c6110351f$var$CLASS_PREFIX + "pagination";
var $7a9bc48c6110351f$export$52f2cca6a5eee805 = $7a9bc48c6110351f$export$cbf8e5a0ab95eda3 + "__page";
var $7a9bc48c6110351f$export$4c82dc32b1c4ace5 = $7a9bc48c6110351f$var$CLASS_PREFIX + "progress";
var $7a9bc48c6110351f$export$2c9b091c749f4409 = $7a9bc48c6110351f$export$4c82dc32b1c4ace5 + "__bar";
var $7a9bc48c6110351f$export$a29701deef84b825 = $7a9bc48c6110351f$var$CLASS_PREFIX + "toggle";
var $7a9bc48c6110351f$export$d9d247d51b430dbb = $7a9bc48c6110351f$export$a29701deef84b825 + "__play";
var $7a9bc48c6110351f$export$3529f201a419925b = $7a9bc48c6110351f$export$a29701deef84b825 + "__pause";
var $7a9bc48c6110351f$export$3e5381ee3fab8374 = $7a9bc48c6110351f$var$CLASS_PREFIX + "spinner";
var $7a9bc48c6110351f$export$bb78d7c200da8960 = $7a9bc48c6110351f$var$CLASS_PREFIX + "sr";
var $7a9bc48c6110351f$export$7761661e2d5b9388 = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "initialized";
var $7a9bc48c6110351f$export$72d36ecf3758cb4b = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "active";
var $7a9bc48c6110351f$export$e423ac4972f5e196 = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "prev";
var $7a9bc48c6110351f$export$457a2d20827a2779 = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "next";
var $7a9bc48c6110351f$export$53ca4621bbab9a = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "visible";
var $7a9bc48c6110351f$export$d22ec4ccb7996ba2 = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "loading";
var $7a9bc48c6110351f$export$b6f202a162a09100 = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "focus-in";
var $7a9bc48c6110351f$export$cd908cd1dd625e29 = $7a9bc48c6110351f$var$STATUS_CLASS_PREFIX + "overflow";
var $7a9bc48c6110351f$export$49f9eaea10ebf193 = [
    $7a9bc48c6110351f$export$72d36ecf3758cb4b,
    $7a9bc48c6110351f$export$53ca4621bbab9a,
    $7a9bc48c6110351f$export$e423ac4972f5e196,
    $7a9bc48c6110351f$export$457a2d20827a2779,
    $7a9bc48c6110351f$export$d22ec4ccb7996ba2,
    $7a9bc48c6110351f$export$b6f202a162a09100,
    $7a9bc48c6110351f$export$cd908cd1dd625e29
];
var $7a9bc48c6110351f$export$ba41d43e4a419565 = {
    slide: $7a9bc48c6110351f$export$8d922915837a38d3,
    clone: $7a9bc48c6110351f$export$2c1ba4a4f1aa4947,
    arrows: $7a9bc48c6110351f$export$a26cbd955fecf11e,
    arrow: $7a9bc48c6110351f$export$516e7d18e13a2dca,
    prev: $7a9bc48c6110351f$export$58ea3db24c33b76,
    next: $7a9bc48c6110351f$export$4885afd7098a65c2,
    pagination: $7a9bc48c6110351f$export$cbf8e5a0ab95eda3,
    page: $7a9bc48c6110351f$export$52f2cca6a5eee805,
    spinner: $7a9bc48c6110351f$export$3e5381ee3fab8374
};
function $7a9bc48c6110351f$var$closest(from, selector) {
    if ($7a9bc48c6110351f$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($7a9bc48c6110351f$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $7a9bc48c6110351f$var$FRICTION = 5;
var $7a9bc48c6110351f$var$LOG_INTERVAL = 200;
var $7a9bc48c6110351f$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $7a9bc48c6110351f$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $7a9bc48c6110351f$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $7a9bc48c6110351f$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($7a9bc48c6110351f$export$7f4701ac5e05e39f, destroy);
        on($7a9bc48c6110351f$export$7f4701ac5e05e39f, setup);
        on($7a9bc48c6110351f$export$db40ab7c0855fa5c, update);
        bind(document, $7a9bc48c6110351f$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $7a9bc48c6110351f$var$toggleClass(root, $7a9bc48c6110351f$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $7a9bc48c6110351f$var$ALL_ATTRIBUTES.concat("style");
        $7a9bc48c6110351f$var$empty(slides);
        $7a9bc48c6110351f$var$removeClass(root, rootClasses);
        $7a9bc48c6110351f$var$removeClass(track, trackClasses);
        $7a9bc48c6110351f$var$removeAttribute([
            track,
            list
        ], attrs);
        $7a9bc48c6110351f$var$removeAttribute(root, completely ? attrs : [
            "style",
            $7a9bc48c6110351f$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $7a9bc48c6110351f$var$removeClass(root, rootClasses);
        $7a9bc48c6110351f$var$removeClass(track, trackClasses);
        rootClasses = getClasses($7a9bc48c6110351f$export$93b21159ad85c843);
        trackClasses = getClasses($7a9bc48c6110351f$export$7738b09ac0a98952);
        $7a9bc48c6110351f$var$addClass(root, rootClasses);
        $7a9bc48c6110351f$var$addClass(track, trackClasses);
        $7a9bc48c6110351f$var$setAttribute(root, $7a9bc48c6110351f$var$ARIA_LABEL, options.label);
        $7a9bc48c6110351f$var$setAttribute(root, $7a9bc48c6110351f$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $7a9bc48c6110351f$export$7738b09ac0a98952);
        list = $7a9bc48c6110351f$var$child(track, "." + $7a9bc48c6110351f$export$19cc2a5451235cae);
        $7a9bc48c6110351f$var$assert(track && list, "A track/list element is missing.");
        $7a9bc48c6110351f$var$push(slides, $7a9bc48c6110351f$var$children(list, "." + $7a9bc48c6110351f$export$8d922915837a38d3 + ":not(." + $7a9bc48c6110351f$export$2c1ba4a4f1aa4947 + ")"));
        $7a9bc48c6110351f$var$forOwn({
            arrows: $7a9bc48c6110351f$export$a26cbd955fecf11e,
            pagination: $7a9bc48c6110351f$export$cbf8e5a0ab95eda3,
            prev: $7a9bc48c6110351f$export$58ea3db24c33b76,
            next: $7a9bc48c6110351f$export$4885afd7098a65c2,
            bar: $7a9bc48c6110351f$export$2c9b091c749f4409,
            toggle: $7a9bc48c6110351f$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $7a9bc48c6110351f$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $7a9bc48c6110351f$var$uniqueId($7a9bc48c6110351f$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$7a9bc48c6110351f$var$getAttribute(root, $7a9bc48c6110351f$var$ROLE) && root.tagName !== "SECTION" && role) $7a9bc48c6110351f$var$setAttribute(root, $7a9bc48c6110351f$var$ROLE, role);
        $7a9bc48c6110351f$var$setAttribute(root, $7a9bc48c6110351f$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $7a9bc48c6110351f$var$setAttribute(list, $7a9bc48c6110351f$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $7a9bc48c6110351f$var$query(root, selector);
        return elm && $7a9bc48c6110351f$var$closest(elm, "." + $7a9bc48c6110351f$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $7a9bc48c6110351f$export$93b21159ad85c843 && $7a9bc48c6110351f$export$72d36ecf3758cb4b
        ];
    }
    return $7a9bc48c6110351f$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $7a9bc48c6110351f$export$e5a58a5ee5b54c22 = "slide";
var $7a9bc48c6110351f$export$f42383286ed1223d = "loop";
var $7a9bc48c6110351f$export$742b62a5690c060 = "fade";
function $7a9bc48c6110351f$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $7a9bc48c6110351f$var$getAttribute(slide, "style");
    var label = $7a9bc48c6110351f$var$getAttribute(slide, $7a9bc48c6110351f$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $7a9bc48c6110351f$var$child(slide, "." + $7a9bc48c6110351f$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $7a9bc48c6110351f$var$pad(index + 1);
            $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ROLE, pagination ? "tabpanel" : "group");
            $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_LABEL, label || $7a9bc48c6110351f$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $7a9bc48c6110351f$var$apply(emit, $7a9bc48c6110351f$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $7a9bc48c6110351f$var$apply(emit, $7a9bc48c6110351f$export$6d5af59619d10e6a, self));
        on([
            $7a9bc48c6110351f$export$fe5802204b967f0d,
            $7a9bc48c6110351f$export$f0af896383d5adff,
            $7a9bc48c6110351f$export$ff8164bff3202b9
        ], update);
        on($7a9bc48c6110351f$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($7a9bc48c6110351f$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $7a9bc48c6110351f$var$removeClass(slide, $7a9bc48c6110351f$export$49f9eaea10ebf193);
        $7a9bc48c6110351f$var$removeAttribute(slide, $7a9bc48c6110351f$var$ALL_ATTRIBUTES);
        $7a9bc48c6110351f$var$setAttribute(slide, "style", styles);
        $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_LABEL, $7a9bc48c6110351f$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_CONTROLS, controls);
        $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $7a9bc48c6110351f$var$removeAttribute(slide, $7a9bc48c6110351f$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $7a9bc48c6110351f$var$toggleClass(slide, $7a9bc48c6110351f$export$e423ac4972f5e196, index === curr - 1);
            $7a9bc48c6110351f$var$toggleClass(slide, $7a9bc48c6110351f$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $7a9bc48c6110351f$var$hasClass(slide, $7a9bc48c6110351f$export$72d36ecf3758cb4b)) {
            $7a9bc48c6110351f$var$toggleClass(slide, $7a9bc48c6110351f$export$72d36ecf3758cb4b, active);
            $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $7a9bc48c6110351f$export$92e3eae133acac4c : $7a9bc48c6110351f$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $7a9bc48c6110351f$var$MOVING,
            $7a9bc48c6110351f$var$SCROLLING
        ])) $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$ARIA_HIDDEN, hidden || "");
        $7a9bc48c6110351f$var$setAttribute($7a9bc48c6110351f$var$queryAll(slide, options.focusableNodes || ""), $7a9bc48c6110351f$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $7a9bc48c6110351f$var$setAttribute(slide, $7a9bc48c6110351f$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $7a9bc48c6110351f$var$hasClass(slide, $7a9bc48c6110351f$export$53ca4621bbab9a)) {
            $7a9bc48c6110351f$var$toggleClass(slide, $7a9bc48c6110351f$export$53ca4621bbab9a, visible);
            emit(visible ? $7a9bc48c6110351f$export$6a5b3445e4066a53 : $7a9bc48c6110351f$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $7a9bc48c6110351f$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $7a9bc48c6110351f$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($7a9bc48c6110351f$export$742b62a5690c060)) return isActive();
        var trackRect = $7a9bc48c6110351f$var$rect(Components.Elements.track);
        var slideRect = $7a9bc48c6110351f$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $7a9bc48c6110351f$var$floor(trackRect[left]) <= $7a9bc48c6110351f$var$ceil(slideRect[left]) && $7a9bc48c6110351f$var$floor(slideRect[right]) <= $7a9bc48c6110351f$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $7a9bc48c6110351f$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($7a9bc48c6110351f$export$f42383286ed1223d))) diff = $7a9bc48c6110351f$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $7a9bc48c6110351f$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($7a9bc48c6110351f$export$7f4701ac5e05e39f, destroy);
        on($7a9bc48c6110351f$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $7a9bc48c6110351f$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $7a9bc48c6110351f$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $7a9bc48c6110351f$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $7a9bc48c6110351f$var$forEach(items, function(slide) {
            if ($7a9bc48c6110351f$var$isString(slide)) slide = $7a9bc48c6110351f$var$parseHtml(slide);
            if ($7a9bc48c6110351f$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $7a9bc48c6110351f$var$before(slide, ref) : $7a9bc48c6110351f$var$append(list, slide);
                $7a9bc48c6110351f$var$addClass(slide, options.classes.slide);
                observeImages(slide, $7a9bc48c6110351f$var$apply(emit, $7a9bc48c6110351f$export$7e019dae5103a285));
            }
        });
        emit($7a9bc48c6110351f$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $7a9bc48c6110351f$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($7a9bc48c6110351f$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($7a9bc48c6110351f$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $7a9bc48c6110351f$var$isString(matcher) ? $7a9bc48c6110351f$var$matches(Slide2.slide, matcher) : $7a9bc48c6110351f$var$includes($7a9bc48c6110351f$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $7a9bc48c6110351f$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $7a9bc48c6110351f$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $7a9bc48c6110351f$export$efff0f5979573c99($7a9bc48c6110351f$var$apply(emit, $7a9bc48c6110351f$export$7e019dae5103a285)));
        on([
            $7a9bc48c6110351f$export$db40ab7c0855fa5c,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f
        ], init);
        on($7a9bc48c6110351f$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $7a9bc48c6110351f$export$97170d9824b89709;
        $7a9bc48c6110351f$var$style(root, "maxWidth", $7a9bc48c6110351f$var$unit(options.width));
        $7a9bc48c6110351f$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $7a9bc48c6110351f$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $7a9bc48c6110351f$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $7a9bc48c6110351f$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $7a9bc48c6110351f$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($7a9bc48c6110351f$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $7a9bc48c6110351f$var$toggleClass(root, $7a9bc48c6110351f$export$cd908cd1dd625e29, overflow);
                emit($7a9bc48c6110351f$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $7a9bc48c6110351f$var$unit(padding[prop] || ($7a9bc48c6110351f$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $7a9bc48c6110351f$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $7a9bc48c6110351f$var$unit(options.height || $7a9bc48c6110351f$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $7a9bc48c6110351f$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $7a9bc48c6110351f$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $7a9bc48c6110351f$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $7a9bc48c6110351f$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $7a9bc48c6110351f$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $7a9bc48c6110351f$var$rect(Slide.slide)[resolve("right")];
            var left = $7a9bc48c6110351f$var$rect(list)[resolve("left")];
            return $7a9bc48c6110351f$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($7a9bc48c6110351f$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($7a9bc48c6110351f$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($7a9bc48c6110351f$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $7a9bc48c6110351f$var$MULTIPLIER = 2;
function $7a9bc48c6110351f$var$Clones(Splide2, Components2, options) {
    var event = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($7a9bc48c6110351f$export$7f4701ac5e05e39f, remount);
        on([
            $7a9bc48c6110351f$export$db40ab7c0855fa5c,
            $7a9bc48c6110351f$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $7a9bc48c6110351f$var$remove(clones);
        $7a9bc48c6110351f$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($7a9bc48c6110351f$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$7a9bc48c6110351f$var$push(slides, slides);
            $7a9bc48c6110351f$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $7a9bc48c6110351f$var$before(clone, slides[0].slide) : $7a9bc48c6110351f$var$append(_$Elements.list, clone);
                $7a9bc48c6110351f$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $7a9bc48c6110351f$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $7a9bc48c6110351f$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($7a9bc48c6110351f$export$f42383286ed1223d)) clones2 = 0;
        else if ($7a9bc48c6110351f$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $7a9bc48c6110351f$var$ceil($7a9bc48c6110351f$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $7a9bc48c6110351f$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $7a9bc48c6110351f$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $7a9bc48c6110351f$export$d300dc1a2634364b,
            $7a9bc48c6110351f$export$d637eba1e9e28482,
            $7a9bc48c6110351f$export$db40ab7c0855fa5c,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($7a9bc48c6110351f$var$MOVING);
        emit($7a9bc48c6110351f$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($7a9bc48c6110351f$var$IDLE);
            emit($7a9bc48c6110351f$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($7a9bc48c6110351f$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $7a9bc48c6110351f$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($7a9bc48c6110351f$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($7a9bc48c6110351f$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($7a9bc48c6110351f$var$ceil($7a9bc48c6110351f$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $7a9bc48c6110351f$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $7a9bc48c6110351f$var$rect(list)[left] - $7a9bc48c6110351f$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($7a9bc48c6110351f$export$e5a58a5ee5b54c22)) position = $7a9bc48c6110351f$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $7a9bc48c6110351f$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $7a9bc48c6110351f$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $7a9bc48c6110351f$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($7a9bc48c6110351f$export$f42383286ed1223d);
    var isSlide = Splide2.is($7a9bc48c6110351f$export$e5a58a5ee5b54c22);
    var getNext = $7a9bc48c6110351f$var$apply(getAdjacent, false);
    var getPrev = $7a9bc48c6110351f$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $7a9bc48c6110351f$export$db40ab7c0855fa5c,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f,
            $7a9bc48c6110351f$export$28dea85f216954dc
        ], init);
        on($7a9bc48c6110351f$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $7a9bc48c6110351f$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($7a9bc48c6110351f$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $7a9bc48c6110351f$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($7a9bc48c6110351f$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $7a9bc48c6110351f$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$7a9bc48c6110351f$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($7a9bc48c6110351f$var$between(0, dest, from, true) || $7a9bc48c6110351f$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $7a9bc48c6110351f$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $7a9bc48c6110351f$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $7a9bc48c6110351f$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $7a9bc48c6110351f$var$min(index, endIndex) : $7a9bc48c6110351f$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $7a9bc48c6110351f$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$7a9bc48c6110351f$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $7a9bc48c6110351f$var$MOVING,
            $7a9bc48c6110351f$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $7a9bc48c6110351f$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $7a9bc48c6110351f$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $7a9bc48c6110351f$var$SIZE = 40;
function $7a9bc48c6110351f$var$Arrows(Splide2, Components2, options) {
    var event = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($7a9bc48c6110351f$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $7a9bc48c6110351f$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $7a9bc48c6110351f$var$display(wrapper, enabled ? "" : "none");
            $7a9bc48c6110351f$var$addClass(wrapper, wrapperClasses = $7a9bc48c6110351f$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $7a9bc48c6110351f$var$setAttribute([
                    prev,
                    next
                ], $7a9bc48c6110351f$var$ARIA_CONTROLS, track.id);
                emit($7a9bc48c6110351f$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $7a9bc48c6110351f$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $7a9bc48c6110351f$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $7a9bc48c6110351f$var$removeAttribute([
            prev,
            next
        ], $7a9bc48c6110351f$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $7a9bc48c6110351f$export$d300dc1a2634364b,
            $7a9bc48c6110351f$export$fe5802204b967f0d,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f,
            $7a9bc48c6110351f$export$ff8164bff3202b9,
            $7a9bc48c6110351f$export$28dea85f216954dc
        ], update);
        bind(next, "click", $7a9bc48c6110351f$var$apply(go, ">"));
        bind(prev, "click", $7a9bc48c6110351f$var$apply(go, "<"));
    }
    function go(control) {
        _$Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $7a9bc48c6110351f$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $7a9bc48c6110351f$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $7a9bc48c6110351f$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $7a9bc48c6110351f$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $7a9bc48c6110351f$var$SIZE + " " + $7a9bc48c6110351f$var$SIZE + '" width="' + $7a9bc48c6110351f$var$SIZE + '" height="' + $7a9bc48c6110351f$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $7a9bc48c6110351f$var$PATH) + '" />';
        return $7a9bc48c6110351f$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $7a9bc48c6110351f$var$setAttribute(prev, $7a9bc48c6110351f$var$ARIA_LABEL, prevLabel);
            $7a9bc48c6110351f$var$setAttribute(next, $7a9bc48c6110351f$var$ARIA_LABEL, nextLabel);
            emit($7a9bc48c6110351f$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $7a9bc48c6110351f$var$INTERVAL_DATA_ATTRIBUTE = $7a9bc48c6110351f$var$DATA_ATTRIBUTE + "-interval";
function $7a9bc48c6110351f$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $7a9bc48c6110351f$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $7a9bc48c6110351f$var$setAttribute(toggle, $7a9bc48c6110351f$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $7a9bc48c6110351f$export$2aa493d7c3275167,
            $7a9bc48c6110351f$export$49801896908b5e33,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($7a9bc48c6110351f$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($7a9bc48c6110351f$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($7a9bc48c6110351f$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $7a9bc48c6110351f$var$toggleClass(toggle, $7a9bc48c6110351f$export$72d36ecf3758cb4b, !stopped);
            $7a9bc48c6110351f$var$setAttribute(toggle, $7a9bc48c6110351f$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $7a9bc48c6110351f$var$style(bar, "width", rate * 100 + "%");
        emit($7a9bc48c6110351f$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$7a9bc48c6110351f$var$getAttribute(Slide.slide, $7a9bc48c6110351f$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $7a9bc48c6110351f$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($7a9bc48c6110351f$export$9f64346e17f0ec8e, $7a9bc48c6110351f$var$apply(toggle, true));
            on([
                $7a9bc48c6110351f$export$d300dc1a2634364b,
                $7a9bc48c6110351f$export$db40ab7c0855fa5c,
                $7a9bc48c6110351f$export$7f4701ac5e05e39f
            ], $7a9bc48c6110351f$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $7a9bc48c6110351f$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $7a9bc48c6110351f$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $7a9bc48c6110351f$var$apply(cover, false)
    };
}
var $7a9bc48c6110351f$var$BOUNCE_DIFF_THRESHOLD = 10;
var $7a9bc48c6110351f$var$BOUNCE_DURATION = 600;
var $7a9bc48c6110351f$var$FRICTION_FACTOR = 0.6;
var $7a9bc48c6110351f$var$BASE_VELOCITY = 1.5;
var $7a9bc48c6110351f$var$MIN_DURATION = 800;
function $7a9bc48c6110351f$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($7a9bc48c6110351f$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($7a9bc48c6110351f$export$2aa493d7c3275167, clear);
        on([
            $7a9bc48c6110351f$export$db40ab7c0855fa5c,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $7a9bc48c6110351f$var$sign(destination) * size * $7a9bc48c6110351f$var$floor($7a9bc48c6110351f$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $7a9bc48c6110351f$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $7a9bc48c6110351f$var$max($7a9bc48c6110351f$var$abs(destination - from) / $7a9bc48c6110351f$var$BASE_VELOCITY, $7a9bc48c6110351f$var$MIN_DURATION);
        callback = onScrolled;
        interval = $7a9bc48c6110351f$export$46ad21b25b6dccf0(duration, onEnd, $7a9bc48c6110351f$var$apply(update, from, destination, noConstrain), 1);
        set($7a9bc48c6110351f$var$SCROLLING);
        emit($7a9bc48c6110351f$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($7a9bc48c6110351f$var$IDLE);
        callback && callback();
        emit($7a9bc48c6110351f$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $7a9bc48c6110351f$var$FRICTION_FACTOR;
            if ($7a9bc48c6110351f$var$abs(diff) < $7a9bc48c6110351f$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $7a9bc48c6110351f$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $7a9bc48c6110351f$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $7a9bc48c6110351f$var$POINTER_MOVE_EVENTS, $7a9bc48c6110351f$var$noop, $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $7a9bc48c6110351f$var$POINTER_UP_EVENTS, $7a9bc48c6110351f$var$noop, $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $7a9bc48c6110351f$var$POINTER_DOWN_EVENTS, onPointerDown, $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $7a9bc48c6110351f$var$prevent);
        on([
            $7a9bc48c6110351f$export$d300dc1a2634364b,
            $7a9bc48c6110351f$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $7a9bc48c6110351f$var$MOVING,
                        $7a9bc48c6110351f$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $7a9bc48c6110351f$var$POINTER_MOVE_EVENTS, onPointerMove, $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $7a9bc48c6110351f$var$POINTER_UP_EVENTS, onPointerUp, $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $7a9bc48c6110351f$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($7a9bc48c6110351f$var$DRAGGING)) {
            state.set($7a9bc48c6110351f$var$DRAGGING);
            emit($7a9bc48c6110351f$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $7a9bc48c6110351f$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($7a9bc48c6110351f$export$8e9f636d2c722196);
                $7a9bc48c6110351f$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $7a9bc48c6110351f$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($7a9bc48c6110351f$var$DRAGGING)) {
            state.set($7a9bc48c6110351f$var$IDLE);
            emit($7a9bc48c6110351f$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $7a9bc48c6110351f$var$prevent(e);
        }
        unbind(target, $7a9bc48c6110351f$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $7a9bc48c6110351f$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $7a9bc48c6110351f$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($7a9bc48c6110351f$export$742b62a5690c060)) _$Controller.go(orient($7a9bc48c6110351f$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($7a9bc48c6110351f$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $7a9bc48c6110351f$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $7a9bc48c6110351f$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $7a9bc48c6110351f$var$abs(diffCoord(e)) > $7a9bc48c6110351f$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($7a9bc48c6110351f$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $7a9bc48c6110351f$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $7a9bc48c6110351f$var$sign(velocity) * $7a9bc48c6110351f$var$min($7a9bc48c6110351f$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $7a9bc48c6110351f$var$timeOf(e) - $7a9bc48c6110351f$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($7a9bc48c6110351f$export$e5a58a5ee5b54c22) ? $7a9bc48c6110351f$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$7a9bc48c6110351f$var$matches(target2, "." + $7a9bc48c6110351f$export$52f2cca6a5eee805 + ", ." + $7a9bc48c6110351f$export$516e7d18e13a2dca) && (!noDrag || !$7a9bc48c6110351f$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $7a9bc48c6110351f$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $7a9bc48c6110351f$var$ARROW_RIGHT,
    Left: $7a9bc48c6110351f$var$ARROW_LEFT,
    Up: $7a9bc48c6110351f$var$ARROW_UP,
    Down: $7a9bc48c6110351f$var$ARROW_DOWN
};
function $7a9bc48c6110351f$var$normalizeKey(key) {
    key = $7a9bc48c6110351f$var$isString(key) ? key : key.key;
    return $7a9bc48c6110351f$var$NORMALIZATION_MAP[key] || key;
}
var $7a9bc48c6110351f$var$KEYBOARD_EVENT = "keydown";
function $7a9bc48c6110351f$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($7a9bc48c6110351f$export$db40ab7c0855fa5c, destroy);
        on($7a9bc48c6110351f$export$db40ab7c0855fa5c, init);
        on($7a9bc48c6110351f$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $7a9bc48c6110351f$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $7a9bc48c6110351f$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $7a9bc48c6110351f$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $7a9bc48c6110351f$var$normalizeKey(e);
            if (key === resolve($7a9bc48c6110351f$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($7a9bc48c6110351f$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $7a9bc48c6110351f$var$SRC_DATA_ATTRIBUTE = $7a9bc48c6110351f$var$DATA_ATTRIBUTE + "-lazy";
var $7a9bc48c6110351f$var$SRCSET_DATA_ATTRIBUTE = $7a9bc48c6110351f$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $7a9bc48c6110351f$var$IMAGE_SELECTOR = "[" + $7a9bc48c6110351f$var$SRC_DATA_ATTRIBUTE + "], [" + $7a9bc48c6110351f$var$SRCSET_DATA_ATTRIBUTE + "]";
function $7a9bc48c6110351f$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $7a9bc48c6110351f$export$fe5802204b967f0d,
        $7a9bc48c6110351f$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($7a9bc48c6110351f$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $7a9bc48c6110351f$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $7a9bc48c6110351f$var$queryAll(Slide.slide, $7a9bc48c6110351f$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $7a9bc48c6110351f$var$getAttribute(img, $7a9bc48c6110351f$var$SRC_DATA_ATTRIBUTE);
                var srcset = $7a9bc48c6110351f$var$getAttribute(img, $7a9bc48c6110351f$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $7a9bc48c6110351f$var$child(parent, "." + className) || $7a9bc48c6110351f$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $7a9bc48c6110351f$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $7a9bc48c6110351f$var$addClass(data[1].slide, $7a9bc48c6110351f$export$d22ec4ccb7996ba2);
        bind(img, "load error", $7a9bc48c6110351f$var$apply(onLoad, data));
        $7a9bc48c6110351f$var$setAttribute(img, "src", $7a9bc48c6110351f$var$getAttribute(img, $7a9bc48c6110351f$var$SRC_DATA_ATTRIBUTE));
        $7a9bc48c6110351f$var$setAttribute(img, "srcset", $7a9bc48c6110351f$var$getAttribute(img, $7a9bc48c6110351f$var$SRCSET_DATA_ATTRIBUTE));
        $7a9bc48c6110351f$var$removeAttribute(img, $7a9bc48c6110351f$var$SRC_DATA_ATTRIBUTE);
        $7a9bc48c6110351f$var$removeAttribute(img, $7a9bc48c6110351f$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $7a9bc48c6110351f$var$removeClass(Slide.slide, $7a9bc48c6110351f$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $7a9bc48c6110351f$var$remove(data[2]);
            $7a9bc48c6110351f$var$display(img, "");
            emit($7a9bc48c6110351f$export$9f64346e17f0ec8e, img, Slide);
            emit($7a9bc48c6110351f$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $7a9bc48c6110351f$var$apply($7a9bc48c6110351f$var$empty, entries),
        check: check
    };
}
function $7a9bc48c6110351f$var$Pagination(Splide2, Components2, options) {
    var event = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $7a9bc48c6110351f$export$db40ab7c0855fa5c,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f,
            $7a9bc48c6110351f$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $7a9bc48c6110351f$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $7a9bc48c6110351f$export$2aa493d7c3275167,
                $7a9bc48c6110351f$export$49801896908b5e33,
                $7a9bc48c6110351f$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($7a9bc48c6110351f$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $7a9bc48c6110351f$var$remove(placeholder ? $7a9bc48c6110351f$var$slice(list.children) : list);
            $7a9bc48c6110351f$var$removeClass(list, paginationClasses);
            $7a9bc48c6110351f$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $7a9bc48c6110351f$var$ceil(length / perPage);
        list = placeholder || $7a9bc48c6110351f$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $7a9bc48c6110351f$var$addClass(list, paginationClasses = $7a9bc48c6110351f$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $7a9bc48c6110351f$var$setAttribute(list, $7a9bc48c6110351f$var$ROLE, "tablist");
        $7a9bc48c6110351f$var$setAttribute(list, $7a9bc48c6110351f$var$ARIA_LABEL, i18n.select);
        $7a9bc48c6110351f$var$setAttribute(list, $7a9bc48c6110351f$var$ARIA_ORIENTATION, getDirection() === $7a9bc48c6110351f$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $7a9bc48c6110351f$var$create("li", null, list);
            var button = $7a9bc48c6110351f$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $7a9bc48c6110351f$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $7a9bc48c6110351f$var$apply(onKeydown, i));
            $7a9bc48c6110351f$var$setAttribute(li, $7a9bc48c6110351f$var$ROLE, "presentation");
            $7a9bc48c6110351f$var$setAttribute(button, $7a9bc48c6110351f$var$ROLE, "tab");
            $7a9bc48c6110351f$var$setAttribute(button, $7a9bc48c6110351f$var$ARIA_CONTROLS, controls.join(" "));
            $7a9bc48c6110351f$var$setAttribute(button, $7a9bc48c6110351f$var$ARIA_LABEL, $7a9bc48c6110351f$var$format(text, i + 1));
            $7a9bc48c6110351f$var$setAttribute(button, $7a9bc48c6110351f$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $7a9bc48c6110351f$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($7a9bc48c6110351f$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($7a9bc48c6110351f$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $7a9bc48c6110351f$var$focus(item.button);
            go(">" + nextPage);
            $7a9bc48c6110351f$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[_$Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $7a9bc48c6110351f$var$removeClass(button, $7a9bc48c6110351f$export$72d36ecf3758cb4b);
            $7a9bc48c6110351f$var$removeAttribute(button, $7a9bc48c6110351f$var$ARIA_SELECTED);
            $7a9bc48c6110351f$var$setAttribute(button, $7a9bc48c6110351f$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $7a9bc48c6110351f$var$addClass(_button, $7a9bc48c6110351f$export$72d36ecf3758cb4b);
            $7a9bc48c6110351f$var$setAttribute(_button, $7a9bc48c6110351f$var$ARIA_SELECTED, true);
            $7a9bc48c6110351f$var$setAttribute(_button, $7a9bc48c6110351f$var$TAB_INDEX, "");
        }
        emit($7a9bc48c6110351f$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $7a9bc48c6110351f$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $7a9bc48c6110351f$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $7a9bc48c6110351f$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $7a9bc48c6110351f$export$f188226459c8a3ff(splide);
        event.on($7a9bc48c6110351f$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($7a9bc48c6110351f$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($7a9bc48c6110351f$export$5adb665701eda1ce, onClick);
        on($7a9bc48c6110351f$export$6d5af59619d10e6a, onKeydown);
        on([
            $7a9bc48c6110351f$export$d300dc1a2634364b,
            $7a9bc48c6110351f$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($7a9bc48c6110351f$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $7a9bc48c6110351f$var$setAttribute(Components2.Elements.list, $7a9bc48c6110351f$var$ARIA_ORIENTATION, options.direction === $7a9bc48c6110351f$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($7a9bc48c6110351f$var$includes($7a9bc48c6110351f$var$TRIGGER_KEYS, $7a9bc48c6110351f$var$normalizeKey(e))) {
            onClick(Slide);
            $7a9bc48c6110351f$var$prevent(e);
        }
    }
    return {
        setup: $7a9bc48c6110351f$var$apply(Components2.Media.set, {
            slideFocus: $7a9bc48c6110351f$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $7a9bc48c6110351f$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $7a9bc48c6110351f$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $7a9bc48c6110351f$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($7a9bc48c6110351f$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $7a9bc48c6110351f$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($7a9bc48c6110351f$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $7a9bc48c6110351f$var$SR_REMOVAL_DELAY = 90;
function $7a9bc48c6110351f$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $7a9bc48c6110351f$var$create("span", $7a9bc48c6110351f$export$bb78d7c200da8960);
    var interval = $7a9bc48c6110351f$export$46ad21b25b6dccf0($7a9bc48c6110351f$var$SR_REMOVAL_DELAY, $7a9bc48c6110351f$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $7a9bc48c6110351f$var$setAttribute(track, $7a9bc48c6110351f$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($7a9bc48c6110351f$export$23663268a31b79e2, $7a9bc48c6110351f$var$apply(disable, true));
            on($7a9bc48c6110351f$export$16a1e4f3d0368265, $7a9bc48c6110351f$var$apply(disable, false));
            on([
                $7a9bc48c6110351f$export$fe5802204b967f0d,
                $7a9bc48c6110351f$export$ff8164bff3202b9
            ], $7a9bc48c6110351f$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $7a9bc48c6110351f$var$setAttribute(track, $7a9bc48c6110351f$var$ARIA_BUSY, active);
        if (active) {
            $7a9bc48c6110351f$var$append(track, sr);
            interval.start();
        } else {
            $7a9bc48c6110351f$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $7a9bc48c6110351f$var$removeAttribute(track, [
            $7a9bc48c6110351f$var$ARIA_LIVE,
            $7a9bc48c6110351f$var$ARIA_ATOMIC,
            $7a9bc48c6110351f$var$ARIA_BUSY
        ]);
        $7a9bc48c6110351f$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $7a9bc48c6110351f$var$setAttribute(track, $7a9bc48c6110351f$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $7a9bc48c6110351f$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $7a9bc48c6110351f$var$Media,
    Direction: $7a9bc48c6110351f$var$Direction,
    Elements: $7a9bc48c6110351f$var$Elements,
    Slides: $7a9bc48c6110351f$var$Slides,
    Layout: $7a9bc48c6110351f$var$Layout,
    Clones: $7a9bc48c6110351f$var$Clones,
    Move: $7a9bc48c6110351f$var$Move,
    Controller: $7a9bc48c6110351f$var$Controller,
    Arrows: $7a9bc48c6110351f$var$Arrows,
    Autoplay: $7a9bc48c6110351f$var$Autoplay,
    Cover: $7a9bc48c6110351f$var$Cover,
    Scroll: $7a9bc48c6110351f$var$Scroll,
    Drag: $7a9bc48c6110351f$var$Drag,
    Keyboard: $7a9bc48c6110351f$var$Keyboard,
    LazyLoad: $7a9bc48c6110351f$var$LazyLoad,
    Pagination: $7a9bc48c6110351f$var$Pagination,
    Sync: $7a9bc48c6110351f$var$Sync,
    Wheel: $7a9bc48c6110351f$var$Wheel,
    Live: $7a9bc48c6110351f$var$Live
});
var $7a9bc48c6110351f$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $7a9bc48c6110351f$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $7a9bc48c6110351f$export$ba41d43e4a419565,
    i18n: $7a9bc48c6110351f$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $7a9bc48c6110351f$var$Fade(Splide2, Components2, options) {
    var _$Slides = Components2.Slides;
    function mount() {
        $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2).on([
            $7a9bc48c6110351f$export$d300dc1a2634364b,
            $7a9bc48c6110351f$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $7a9bc48c6110351f$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $7a9bc48c6110351f$var$noop
    };
}
function $7a9bc48c6110351f$var$Slide(Splide2, Components2, options) {
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $7a9bc48c6110351f$var$apply($7a9bc48c6110351f$var$style, list, "transition");
    var endCallback;
    function mount() {
        $7a9bc48c6110351f$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($7a9bc48c6110351f$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        _$Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($7a9bc48c6110351f$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $7a9bc48c6110351f$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $7a9bc48c6110351f$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $7a9bc48c6110351f$export$7254cc27399e90bd($7a9bc48c6110351f$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $7a9bc48c6110351f$var$isString(target) ? $7a9bc48c6110351f$var$query(document, target) : target;
        $7a9bc48c6110351f$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $7a9bc48c6110351f$var$merge({
            label: $7a9bc48c6110351f$var$getAttribute(root, $7a9bc48c6110351f$var$ARIA_LABEL) || "",
            labelledby: $7a9bc48c6110351f$var$getAttribute(root, $7a9bc48c6110351f$var$ARIA_LABELLEDBY) || ""
        }, $7a9bc48c6110351f$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $7a9bc48c6110351f$var$merge(options, JSON.parse($7a9bc48c6110351f$var$getAttribute(root, $7a9bc48c6110351f$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $7a9bc48c6110351f$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($7a9bc48c6110351f$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $7a9bc48c6110351f$var$assert(state.is([
            $7a9bc48c6110351f$var$CREATED,
            $7a9bc48c6110351f$var$DESTROYED
        ]), "Already mounted!");
        state.set($7a9bc48c6110351f$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($7a9bc48c6110351f$export$742b62a5690c060) ? $7a9bc48c6110351f$var$Fade : $7a9bc48c6110351f$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $7a9bc48c6110351f$var$assign({}, $7a9bc48c6110351f$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $7a9bc48c6110351f$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $7a9bc48c6110351f$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($7a9bc48c6110351f$export$d300dc1a2634364b);
        $7a9bc48c6110351f$var$addClass(this.root, $7a9bc48c6110351f$export$7761661e2d5b9388);
        state.set($7a9bc48c6110351f$var$IDLE);
        this.emit($7a9bc48c6110351f$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($7a9bc48c6110351f$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($7a9bc48c6110351f$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($7a9bc48c6110351f$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($7a9bc48c6110351f$var$CREATED)) $7a9bc48c6110351f$export$f188226459c8a3ff(this).on($7a9bc48c6110351f$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $7a9bc48c6110351f$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($7a9bc48c6110351f$export$88c4cf7419e470cd);
            event.destroy();
            completely && $7a9bc48c6110351f$var$empty(this.splides);
            state.set($7a9bc48c6110351f$var$DESTROYED);
        }
        return this;
    };
    $7a9bc48c6110351f$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $7a9bc48c6110351f$export$24494c7438c070bf = $7a9bc48c6110351f$var$_Splide;
$7a9bc48c6110351f$export$24494c7438c070bf.defaults = {};
$7a9bc48c6110351f$export$24494c7438c070bf.STATES = $7a9bc48c6110351f$var$STATES;
var $7a9bc48c6110351f$var$CLASS_RENDERED = "is-rendered";
var $7a9bc48c6110351f$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $7a9bc48c6110351f$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $7a9bc48c6110351f$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $7a9bc48c6110351f$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $7a9bc48c6110351f$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $7a9bc48c6110351f$var$merge($7a9bc48c6110351f$export$f484e977a69c6ba6, defaults || {});
        $7a9bc48c6110351f$var$merge($7a9bc48c6110351f$var$merge(this.options, $7a9bc48c6110351f$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $7a9bc48c6110351f$var$assign({}, $7a9bc48c6110351f$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $7a9bc48c6110351f$var$uniqueId("splide");
        this.Style = new $7a9bc48c6110351f$var$Style(this.id, this.options);
        this.Direction = $7a9bc48c6110351f$var$Direction(null, null, this.options);
        $7a9bc48c6110351f$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $7a9bc48c6110351f$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $7a9bc48c6110351f$var$queryAll(root, "." + $7a9bc48c6110351f$export$2c1ba4a4f1aa4947);
        on($7a9bc48c6110351f$export$d300dc1a2634364b, function() {
            $7a9bc48c6110351f$var$remove($7a9bc48c6110351f$var$child(root, "style"));
        });
        $7a9bc48c6110351f$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $7a9bc48c6110351f$var$push(this.slides, this.contents.map(function(content, index) {
            content = $7a9bc48c6110351f$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $7a9bc48c6110351f$export$72d36ecf3758cb4b : "");
            $7a9bc48c6110351f$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $7a9bc48c6110351f$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $7a9bc48c6110351f$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $7a9bc48c6110351f$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $7a9bc48c6110351f$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $7a9bc48c6110351f$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $7a9bc48c6110351f$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $7a9bc48c6110351f$var$unit(padding[prop] || ($7a9bc48c6110351f$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $7a9bc48c6110351f$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $7a9bc48c6110351f$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $7a9bc48c6110351f$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $7a9bc48c6110351f$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $7a9bc48c6110351f$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($7a9bc48c6110351f$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $7a9bc48c6110351f$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $7a9bc48c6110351f$var$merge($7a9bc48c6110351f$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $7a9bc48c6110351f$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $7a9bc48c6110351f$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $7a9bc48c6110351f$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $7a9bc48c6110351f$export$93b21159ad85c843,
            $7a9bc48c6110351f$export$93b21159ad85c843 + "--" + options.type,
            $7a9bc48c6110351f$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $7a9bc48c6110351f$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $7a9bc48c6110351f$export$93b21159ad85c843 + "--nav",
            $7a9bc48c6110351f$export$72d36ecf3758cb4b,
            !this.config.hidden && $7a9bc48c6110351f$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $7a9bc48c6110351f$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $7a9bc48c6110351f$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $7a9bc48c6110351f$var$forOwn(styles, function(value, key) {
            style += " " + $7a9bc48c6110351f$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$7a9bc48c6110351f$var$push(slides, slides);
        $7a9bc48c6110351f$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $7a9bc48c6110351f$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $7a9bc48c6110351f$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $7a9bc48c6110351f$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $7a9bc48c6110351f$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $7a9bc48c6110351f$var$SIZE + " " + $7a9bc48c6110351f$var$SIZE + '" width="' + $7a9bc48c6110351f$var$SIZE + '" height="' + $7a9bc48c6110351f$var$SIZE + '"><path d="' + (this.options.arrowPath || $7a9bc48c6110351f$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


var $1c9fc4628f92e356$exports = {};

!function(e, t) {
    $1c9fc4628f92e356$exports = t();
}(undefined, function() {
    "use strict";
    var e = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, t = "Expected a function", n = NaN, o = "[object Symbol]", i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, c = /^0o[0-7]+$/i, s = parseInt, u = "object" == typeof e && e && e.Object === Object && e, d = "object" == typeof self && self && self.Object === Object && self, l = u || d || Function("return this")(), f = Object.prototype.toString, m = Math.max, p = Math.min, b = function b() {
        return l.Date.now();
    };
    function v(e, n, o) {
        var i, a, r, c, s, u, d = 0, l = !1, f = !1, v = !0;
        if ("function" != typeof e) throw new TypeError(t);
        function y(t) {
            var _$n = i, _$o = a;
            return i = a = void 0, d = t, c = e.apply(_$o, _$n);
        }
        function h(e) {
            var t = e - u;
            return void 0 === u || t >= n || t < 0 || f && e - d >= r;
        }
        function k() {
            var _$e = b();
            if (h(_$e)) return x(_$e);
            s = setTimeout(k, function(e) {
                var t = n - (e - u);
                return f ? p(t, r - (e - d)) : t;
            }(_$e));
        }
        function x(e) {
            return s = void 0, v && i ? y(e) : (i = a = void 0, c);
        }
        function O() {
            var _$e = b(), t = h(_$e);
            if (i = arguments, a = this, u = _$e, t) {
                if (void 0 === s) return function(e) {
                    return d = e, s = setTimeout(k, n), l ? y(e) : c;
                }(u);
                if (f) return s = setTimeout(k, n), y(u);
            }
            return void 0 === s && (s = setTimeout(k, n)), c;
        }
        return n = w(n) || 0, g(o) && (l = !!o.leading, r = (f = "maxWait" in o) ? m(w(o.maxWait) || 0, n) : r, v = "trailing" in o ? !!o.trailing : v), O.cancel = function() {
            void 0 !== s && clearTimeout(s), d = 0, i = u = a = s = void 0;
        }, O.flush = function() {
            return void 0 === s ? c : x(b());
        }, O;
    }
    function g(e) {
        var t = typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$5f0017c582d45a2d)(e);
        return !!e && ("object" == t || "function" == t);
    }
    function w(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == (typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$5f0017c582d45a2d)(e)) || function(e) {
                return !!e && "object" == typeof e;
            }(e) && f.call(e) == o;
        }(e)) return n;
        if (g(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = g(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(i, "");
        var u = r.test(e);
        return u || c.test(e) ? s(e.slice(2), u ? 2 : 8) : a.test(e) ? n : +e;
    }
    var y = function y(e, n, o) {
        var i = !0, a = !0;
        if ("function" != typeof e) throw new TypeError(t);
        return g(o) && (i = "leading" in o ? !!o.leading : i, a = "trailing" in o ? !!o.trailing : a), v(e, n, {
            leading: i,
            maxWait: n,
            trailing: a
        });
    }, h = "Expected a function", k = NaN, x = "[object Symbol]", O = /^\s+|\s+$/g, j = /^[-+]0x[0-9a-f]+$/i, E = /^0b[01]+$/i, N = /^0o[0-7]+$/i, z = parseInt, C = "object" == typeof e && e && e.Object === Object && e, A = "object" == typeof self && self && self.Object === Object && self, q = C || A || Function("return this")(), L = Object.prototype.toString, T = Math.max, M = Math.min, S = function S() {
        return q.Date.now();
    };
    function D(e) {
        var t = typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$5f0017c582d45a2d)(e);
        return !!e && ("object" == t || "function" == t);
    }
    function H(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == (typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$5f0017c582d45a2d)(e)) || function(e) {
                return !!e && "object" == typeof e;
            }(e) && L.call(e) == x;
        }(e)) return k;
        if (D(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = D(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(O, "");
        var n = E.test(e);
        return n || N.test(e) ? z(e.slice(2), n ? 2 : 8) : j.test(e) ? k : +e;
    }
    var $ = function $(e, t, n) {
        var o, i, a, r, c, s, u = 0, d = !1, l = !1, f = !0;
        if ("function" != typeof e) throw new TypeError(h);
        function m(t) {
            var _$n = o, a = i;
            return o = i = void 0, u = t, r = e.apply(a, _$n);
        }
        function p(e) {
            var _$n = e - s;
            return void 0 === s || _$n >= t || _$n < 0 || l && e - u >= a;
        }
        function b() {
            var _$e = S();
            if (p(_$e)) return v(_$e);
            c = setTimeout(b, function(e) {
                var _$n = t - (e - s);
                return l ? M(_$n, a - (e - u)) : _$n;
            }(_$e));
        }
        function v(e) {
            return c = void 0, f && o ? m(e) : (o = i = void 0, r);
        }
        function g() {
            var _$e = S(), _$n = p(_$e);
            if (o = arguments, i = this, s = _$e, _$n) {
                if (void 0 === c) return function(e) {
                    return u = e, c = setTimeout(b, t), d ? m(e) : r;
                }(s);
                if (l) return c = setTimeout(b, t), m(s);
            }
            return void 0 === c && (c = setTimeout(b, t)), r;
        }
        return t = H(t) || 0, D(n) && (d = !!n.leading, a = (l = "maxWait" in n) ? T(H(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), g.cancel = function() {
            void 0 !== c && clearTimeout(c), u = 0, o = s = i = c = void 0;
        }, g.flush = function() {
            return void 0 === c ? r : v(S());
        }, g;
    }, W = function W() {};
    function P(e) {
        e && e.forEach(function(e) {
            var t = Array.prototype.slice.call(e.addedNodes), n = Array.prototype.slice.call(e.removedNodes);
            if (function e(t) {
                var n = void 0, o = void 0;
                for(n = 0; n < t.length; n += 1){
                    if ((o = t[n]).dataset && o.dataset.aos) return !0;
                    if (o.children && e(o.children)) return !0;
                }
                return !1;
            }(t.concat(n))) return W();
        });
    }
    function Y() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    var _ = {
        isSupported: function isSupported() {
            return !!Y();
        },
        ready: function ready(e, t) {
            var n = window.document, o = new (Y())(P);
            W = t, o.observe(n.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0
            });
        }
    }, B = function B(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, F = function() {
        function e(e, t) {
            for(var n = 0; n < t.length; n++){
                var o = t[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
        }
        return function(t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
        };
    }(), I = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
    }, K = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, G = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, J = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, Q = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
    function R() {
        return navigator.userAgent || navigator.vendor || window.opera || "";
    }
    var U = new (function() {
        function e() {
            B(this, e);
        }
        return F(e, [
            {
                key: "phone",
                value: function value() {
                    var _$e = R();
                    return !(!K.test(_$e) && !G.test(_$e.substr(0, 4)));
                }
            },
            {
                key: "mobile",
                value: function value() {
                    var _$e = R();
                    return !(!J.test(_$e) && !Q.test(_$e.substr(0, 4)));
                }
            },
            {
                key: "tablet",
                value: function value() {
                    return this.mobile() && !this.phone();
                }
            },
            {
                key: "ie11",
                value: function value() {
                    return "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                }
            }
        ]), e;
    }()), V = function V(e, t) {
        var n = void 0;
        return U.ie11() ? (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, {
            detail: t
        }) : n = new CustomEvent(e, {
            detail: t
        }), document.dispatchEvent(n);
    }, X = function X(e) {
        return e.forEach(function(e, t) {
            return function(e, t) {
                var n = e.options, o = e.position, i = e.node, a = (e.data, function a() {
                    e.animated && (function(e, t) {
                        t && t.forEach(function(t) {
                            return e.classList.remove(t);
                        });
                    }(i, n.animatedClassNames), V("aos:out", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !1);
                });
                n.mirror && t >= o.out && !n.once ? a() : t >= o.in ? e.animated || (function(e, t) {
                    t && t.forEach(function(t) {
                        return e.classList.add(t);
                    });
                }(i, n.animatedClassNames), V("aos:in", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !0) : e.animated && !n.once && a();
            }(e, window.pageYOffset);
        });
    }, Z = function Z(e) {
        for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
        return {
            top: n,
            left: t
        };
    }, ee = function ee(e, t, n) {
        var o = e.getAttribute("data-aos-" + t);
        if (void 0 !== o) {
            if ("true" === o) return !0;
            if ("false" === o) return !1;
        }
        return o || n;
    }, te = function te(e, t) {
        return e.forEach(function(e, n) {
            var o = ee(e.node, "mirror", t.mirror), i = ee(e.node, "once", t.once), a = ee(e.node, "id"), r = t.useClassNames && e.node.getAttribute("data-aos"), c = [
                t.animatedClassName
            ].concat(r ? r.split(" ") : []).filter(function(e) {
                return "string" == typeof e;
            });
            t.initClassName && e.node.classList.add(t.initClassName), e.position = {
                in: function(e, t, n) {
                    var o = window.innerHeight, i = ee(e, "anchor"), a = ee(e, "anchor-placement"), r = Number(ee(e, "offset", a ? 0 : t)), c = a || n, s = e;
                    i && document.querySelectorAll(i) && (s = document.querySelectorAll(i)[0]);
                    var u = Z(s).top - o;
                    switch(c){
                        case "top-bottom":
                            break;
                        case "center-bottom":
                            u += s.offsetHeight / 2;
                            break;
                        case "bottom-bottom":
                            u += s.offsetHeight;
                            break;
                        case "top-center":
                            u += o / 2;
                            break;
                        case "center-center":
                            u += o / 2 + s.offsetHeight / 2;
                            break;
                        case "bottom-center":
                            u += o / 2 + s.offsetHeight;
                            break;
                        case "top-top":
                            u += o;
                            break;
                        case "bottom-top":
                            u += o + s.offsetHeight;
                            break;
                        case "center-top":
                            u += o + s.offsetHeight / 2;
                    }
                    return u + r;
                }(e.node, t.offset, t.anchorPlacement),
                out: o && function(e, t) {
                    window.innerHeight;
                    var n = ee(e, "anchor"), o = ee(e, "offset", t), i = e;
                    return n && document.querySelectorAll(n) && (i = document.querySelectorAll(n)[0]), Z(i).top + i.offsetHeight - o;
                }(e.node, t.offset)
            }, e.options = {
                once: i,
                mirror: o,
                animatedClassNames: c,
                id: a
            };
        }), e;
    }, ne = function ne() {
        var e = document.querySelectorAll("[data-aos]");
        return Array.prototype.map.call(e, function(e) {
            return {
                node: e
            };
        });
    }, oe = [], ie = !1, ae = {
        offset: 120,
        delay: 0,
        easing: "ease",
        duration: 400,
        disable: !1,
        once: !1,
        mirror: !1,
        anchorPlacement: "top-bottom",
        startEvent: "DOMContentLoaded",
        animatedClassName: "aos-animate",
        initClassName: "aos-init",
        useClassNames: !1,
        disableMutationObserver: !1,
        throttleDelay: 99,
        debounceDelay: 50
    }, re = function re() {
        return document.all && !window.atob;
    }, ce = function ce() {
        arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (ie = !0), ie && (oe = te(oe, ae), X(oe), window.addEventListener("scroll", y(function() {
            X(oe, ae.once);
        }, ae.throttleDelay)));
    }, se = function se() {
        if (oe = ne(), de(ae.disable) || re()) return ue();
        ce();
    }, ue = function ue() {
        oe.forEach(function(e, t) {
            e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay"), ae.initClassName && e.node.classList.remove(ae.initClassName), ae.animatedClassName && e.node.classList.remove(ae.animatedClassName);
        });
    }, de = function de(e) {
        return !0 === e || "mobile" === e && U.mobile() || "phone" === e && U.phone() || "tablet" === e && U.tablet() || "function" == typeof e && !0 === e();
    };
    return {
        init: function init(e) {
            return ae = I(ae, e), oe = ne(), ae.disableMutationObserver || _.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), ae.disableMutationObserver = !0), ae.disableMutationObserver || _.ready("[data-aos]", se), de(ae.disable) || re() ? ue() : (document.querySelector("body").setAttribute("data-aos-easing", ae.easing), document.querySelector("body").setAttribute("data-aos-duration", ae.duration), document.querySelector("body").setAttribute("data-aos-delay", ae.delay), -1 === [
                "DOMContentLoaded",
                "load"
            ].indexOf(ae.startEvent) ? document.addEventListener(ae.startEvent, function() {
                ce(!0);
            }) : window.addEventListener("load", function() {
                ce(!0);
            }), "DOMContentLoaded" === ae.startEvent && [
                "complete",
                "interactive"
            ].indexOf(document.readyState) > -1 && ce(!0), window.addEventListener("resize", $(ce, ae.debounceDelay, !0)), window.addEventListener("orientationchange", $(ce, ae.debounceDelay, !0)), oe);
        },
        refresh: ce,
        refreshHard: se
    };
});



var $c55bff8fb8cf358b$var$_loop = function(i) {
    $c55bff8fb8cf358b$var$expertises[i].addEventListener("click", function(event) {
        if (!event.target.classList.contains("wp-block-button__link")) $c55bff8fb8cf358b$var$expertises[i].classList.toggle("active");
    });
};
document.addEventListener("DOMContentLoaded", function() {
    if (document.getElementById("slider1")) {
        var resetAndStartProgressBar = function resetAndStartProgressBar() {
            // Clear existing interval to reset the progress bar update
            clearInterval(progressBarUpdateInterval);
            // Reset all progress bars to 0% width
            document.querySelectorAll("#slider2 .progress-bar").forEach(function(bar) {
                bar.style.width = "0%";
            });
            // Calculate the progress increment for each frame (assuming 60fps)
            var increment = 100 / (6000 / 16.67); // Total width divided by number of frames in the interval
            progressBarUpdateInterval = setInterval(function() {
                document.querySelectorAll("#slider2 .progress-bar").forEach(function(bar, index) {
                    if (index === primary.index) {
                        var currentWidth = parseFloat(bar.style.width) || 0;
                        var newWidth = currentWidth + increment;
                        if (newWidth > 100) {
                            newWidth = 100; // Cap the width at 100%
                            clearInterval(progressBarUpdateInterval); // Clear the interval once reaching 100%
                        }
                        bar.style.width = "".concat(newWidth, "%");
                    }
                });
            }, 16.67); // Update approximately every 16.67 milliseconds (~60fps)
        };
        var primary = new (0, $7a9bc48c6110351f$export$24494c7438c070bf)("#slider1", {
            // Sets a fixed height (e.g., 400px)
            height: "480px"
        });
        primary.mount();
        var slides2 = document.querySelectorAll("#slider2 .splide__slide");
        slides2.forEach(function(slide, index) {
            slide.addEventListener("click", function() {
                // Navigate Slider2 to the slide that corresponds to the clicked slide in Slider1
                resetAndStartProgressBar();
                primary.go(index);
            });
        });
        var progressBarUpdateInterval;
        // Initialize the progress bar on load
        resetAndStartProgressBar();
        primary.on("move", function(newIndex) {
            resetAndStartProgressBar();
            // This ensures that the class addition and progress bar reset happen even when Slider1 is navigated through other means (arrows, pagination, etc.)
            document.querySelectorAll("#slider2 .splide__slide").forEach(function(slide, i) {
                slide.classList.remove("is-active"); // Ensure the class is updated correctly on 'moved'
                if (i === newIndex) slide.classList.add("is-active");
            });
        });
    }
});
window.onYouTubeIframeAPIReady = function() {
    (0, $8ce4587015debc57$export$2e2bcd8739ae039)();
};
// Object-fit fix
(0, (/*@__PURE__*/$parcel$interopDefault($31467fba5e5d38e9$exports)))();
(0, $3bcce9df15a46784$export$2e2bcd8739ae039)(".header");
// Init slider
var $c55bff8fb8cf358b$var$sliders = (0, $090fc41b963e5410$export$2e2bcd8739ae039)();
console.log($c55bff8fb8cf358b$var$sliders);
// Expertise items click event
var $c55bff8fb8cf358b$var$expertises = document.querySelectorAll(".card__expertise");
for(var $c55bff8fb8cf358b$var$i = 0; $c55bff8fb8cf358b$var$i < $c55bff8fb8cf358b$var$expertises.length; $c55bff8fb8cf358b$var$i++)$c55bff8fb8cf358b$var$_loop($c55bff8fb8cf358b$var$i);
if (document.getElementById("purpose__slider-rows")) window.addEventListener("load", function() {
    var box1 = document.getElementById("purpose__slider-row1"), docHeight = document.documentElement.offsetHeight, windowWidth = window.innerWidth / 100;
    var box2 = document.getElementById("purpose__slider-row2"), docHeight = document.documentElement.offsetHeight, windowWidth = window.innerWidth / 100;
    var box3 = document.getElementById("purpose__slider-row3"), docHeight = document.documentElement.offsetHeight, windowWidth = window.innerWidth / 100;
    var box4 = document.getElementById("purpose__slider-row4"), docHeight = document.documentElement.offsetHeight, windowWidth = window.innerWidth / 100;
    window.addEventListener("scroll", function() {
        // normalize scroll position as percentage
        var scrolled = windowWidth * (window.scrollY / (docHeight - window.innerHeight)) * 3, transformValue1 = "translateX(" + scrolled + "px)", transformValue2 = "translateX(-" + scrolled + "px)", transformValue3 = "translateX(" + scrolled + "px)";
        box1.style.WebkitTransform = transformValue1;
        box1.style.MozTransform = transformValue1;
        box1.style.OTransform = transformValue1;
        box1.style.transform = transformValue1;
        box2.style.WebkitTransform = transformValue2;
        box2.style.MozTransform = transformValue2;
        box2.style.OTransform = transformValue2;
        box2.style.transform = transformValue2;
        box3.style.WebkitTransform = transformValue3;
        box3.style.MozTransform = transformValue3;
        box3.style.OTransform = transformValue3;
        box3.style.transform = transformValue3;
        box4.style.WebkitTransform = transformValue2;
        box4.style.MozTransform = transformValue2;
        box4.style.OTransform = transformValue2;
        box4.style.transform = transformValue2;
    }, false);
}, false);
document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll(".wp-block-media-text__media");
    elements.forEach(function(element) {
        element.setAttribute("data-aos", "fade-up");
    });
    // ..
    (0, (/*@__PURE__*/$parcel$interopDefault($1c9fc4628f92e356$exports))).init();
});
if (document.querySelector(".locations__check")) {
    var $c55bff8fb8cf358b$var$box = document.querySelector(".locations__check");
    $c55bff8fb8cf358b$var$box.addEventListener("click", function(event) {
        var xHor = event.offsetX / $c55bff8fb8cf358b$var$box.offsetWidth * 100;
        var yVer = event.offsetY / $c55bff8fb8cf358b$var$box.offsetHeight * 100;
        alert(xHor + "---" + yVer);
    });
}

})();
//# sourceMappingURL=app.js.map
